export const en = {
  'common.language': 'Language',
  'common.environment': 'Environment',
  'is.reachable': 'is reachable',
  'is.not.reachable': 'is not reachable',
  'not.found.message': 'This page does not exist.',
  'common.back': 'Back',
  'an.error.occurred': 'An error occurred',
  'common.back-office': 'Back-office',
  'common.french': 'French',
  'common.english': 'English',
  'common.routing.game-mechanics': 'Game mechanics',
  'common.routing.dialog': 'Dialogs',
  'common.routing.image': 'Image click',
  'common.routing.multiple-choice': 'Multiple choice questions',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'Single choice questions',
  'common.routing.users': 'Users',
  'common.routing.learnerProfile': 'User profile',
  'common.routing.groups': 'Groups',
  'common.routing.files': 'Files',
  'common.routing.dashboard': 'Dashboard',
  'common.routing.statistics': 'Statistics',
  'common.routing.sessions': 'Sessions',
  'common.routing.account': 'My account',
  'common.routing.settings': 'Customization',
  'common.routing.modules': 'Modules',
  'common.routing.certificates': 'Certificates',
  'common.routing.reminders': 'Email reminders',
  'common.routing.survey': 'Satisfaction survey',
  'common.routing.documents': 'Documents',
  'common.routing.quality': 'Continuous improvement',
  'common.routing.accommodations': 'Disability support',
  'common.routing.complaints': 'Complaints',
  'documents.title': 'Documents',
  'documents.intro': 'The documents handed to your learners: internal rules, programme, terms, welcome booklet. Each learner finds them on their path screen and declares they read them: the proof of delivery Qualiopi asks for (indicator 9).',
  'documents.empty': 'No document. Upload your internal rules, your welcome booklet or your training programme.',
  'documents.allSessions': 'Every path',
  'documents.required': 'To accept before starting',
  'documents.requiredHelp': 'The learner cannot open any module until they declare they read it. A learner who already started is not blocked.',
  'documents.requiredBadge': 'To accept',
  'documents.optional': 'Available',
  'documents.download': 'Download',
  'documents.archive': 'Archive',
  'documents.saved': 'Document saved.',
  'documents.uploaded': 'Document uploaded.',
  'documents.archived': 'Document archived.',
  'documents.saveFailed': 'Saving failed. Try again.',
  'documents.downloadFailed': 'The download failed.',
  'documents.column.title': 'Title',
  'documents.column.session': 'Path',
  'documents.column.required': 'Reading',
  'documents.column.acks': 'Acknowledgements',
  'documents.column.actions': 'Actions',
  'documents.new.button': 'Add a document',
  'documents.new.title': 'Add a document',
  'documents.new.description': 'A PDF of 10 MB at most. Choose which path, or all of them, and whether it must be accepted before starting.',
  'documents.new.pick': 'Choose a PDF',
  'documents.new.noFile': 'No file chosen',
  'documents.new.processing': 'Saving the document…',
  'documents.new.submit': 'Upload the document',
  'documents.error.notPdf': 'This file is not a PDF.',
  'documents.error.tooLarge': 'The file exceeds 10 MB.',
  'documents.error.limit': 'You reached 50 documents: archive one before adding another.',
  'documents.error.noFile': 'Choose a file.',
  'documents.error.noTitle': 'Give the document a title.',
  'documents.error.network': 'The upload did not go through. Check your connection and try again.',
  'documents.error.unknown': 'The upload failed. Try again.',
  'documents.acks.open': 'See the acknowledgements',
  'documents.acks.count_one': '{{count}} learner',
  'documents.acks.count_other': '{{count}} learners',
  'documents.acks.title': 'Acknowledgements — {{title}}',
  'documents.acks.description': 'The learners who declared they read the document, and when.',
  'documents.acks.empty': 'Nobody has declared reading it yet.',
  'documents.acks.learner': 'Learner',
  'documents.acks.at': 'Read on',
  'documents.acks.export': 'Export (CSV)',
  'documents.acks.fileName': 'Acknowledgements',
  'documents.archiveConfirm.title': 'Archive this document?',
  'documents.archiveConfirm.body': 'Learners will no longer see “{{title}}”. Its acknowledgements are kept, as proof of delivery.',
  'quality.title': 'Continuous improvement',
  'quality.intro': 'The actions decided from feedback (surveys, complaints, dropouts, audits) and their measured effect, then the risks to the quality of your trainings. Visible to administrators only.',
  'quality.tabs': 'Register',
  'quality.export': 'Export (CSV)',
  'quality.open': 'Open',
  'quality.saved': 'Saved.',
  'quality.saveFailed': 'Saving failed. Try again.',
  'quality.column.title': 'Title',
  'quality.column.status': 'Status',
  'quality.column.owner': 'Owner',
  'quality.column.actions': 'Actions',
  'quality.origin.survey': 'Survey',
  'quality.origin.complaint': 'Complaint',
  'quality.origin.dropout': 'Dropout',
  'quality.origin.audit': 'Audit',
  'quality.origin.review': 'Internal review',
  'quality.origin.other': 'Other',
  'quality.actionStatus.planned': 'Planned',
  'quality.actionStatus.inProgress': 'In progress',
  'quality.actionStatus.done': 'Done',
  'quality.actionStatus.cancelled': 'Cancelled',
  'quality.riskStatus.open': 'To address',
  'quality.riskStatus.mitigated': 'Mitigated',
  'quality.riskStatus.closed': 'Closed',
  'quality.score.low': 'low',
  'quality.score.medium': 'medium',
  'quality.score.high': 'high',
  'quality.actions.title': 'Improvement actions',
  'quality.actions.empty': 'No action yet. Write down here what you decide from feedback, and what it changed.',
  'quality.actions.fileName': 'Improvement actions',
  'quality.actions.createdOn': 'Created on {{date}}',
  'quality.actions.doneOn': 'Done on {{date}}',
  'quality.actions.originPlaceholder': 'Where does this action come from?',
  'quality.actions.descriptionHelp': 'What was observed and what is decided.',
  'quality.actions.effectHelp': 'What the action changed, measured if possible (satisfaction, dropout rate, complaints…).',
  'quality.actions.new.title': 'New improvement action',
  'quality.actions.new.description': 'A decision taken from feedback: state where it comes from, what is decided, who carries it and by when.',
  'quality.actions.new.button': 'New action',
  'quality.actions.new.submit': 'Save the action',
  'quality.actions.column.origin': 'Origin',
  'quality.actions.column.description': 'Finding and decision',
  'quality.actions.column.dueDate': 'Due date',
  'quality.actions.column.effect': 'Measured effect',
  'quality.actions.column.createdAt': 'Created on',
  'quality.actions.column.doneAt': 'Done on',
  'quality.risks.title': 'Quality risks',
  'quality.risks.empty': 'No risk identified. List what could degrade your trainings: trainer unavailable, outdated content, platform outage…',
  'quality.risks.fileName': 'Quality risks',
  'quality.risks.severityHelp': 'Severity = likelihood × impact, from 1 to 9: here {{severity}}.',
  'quality.risks.severityValue': '{{severity}} ({{likelihood}} × {{impact}})',
  'quality.risks.new.title': 'New risk',
  'quality.risks.new.button': 'New risk',
  'quality.risks.new.submit': 'Save the risk',
  'quality.risks.column.description': 'Description',
  'quality.risks.column.likelihood': 'Likelihood',
  'quality.risks.column.impact': 'Impact',
  'quality.risks.column.severity': 'Severity',
  'quality.risks.column.mitigation': 'Mitigation',
  'quality.risks.column.reviewedAt': 'Last review',
  'accommodation.title': 'Need an accommodation?',
  'accommodation.intro': 'If you need an adjustment to follow your trainings (extra time, subtitles, larger text…), tell your organization.',
  'accommodation.referent': 'Your disability referent: {{who}}',
  'accommodation.noReferent': 'Your organization has not named a referent yet; your request still reaches them.',
  'accommodation.needs': 'What do you need?',
  'accommodation.needsHelp': 'Only describe the adjustment you would like: there is no need to mention your health condition.',
  'accommodation.consent': 'I agree that {{org}} uses this information to adapt my training. Only its administrators will see it, and I can withdraw my request at any time.',
  'accommodation.send': 'Send my request',
  'accommodation.yourRequest': 'Your request',
  'accommodation.response': 'Your organization\'s answer:',
  'accommodation.edit': 'Edit',
  'accommodation.withdraw': 'Withdraw my request',
  'accommodation.withdrawConfirm.title': 'Withdraw your request?',
  'accommodation.withdrawConfirm.body': 'It will be erased, along with your organization\'s answer. You can send a new one.',
  'accommodation.sent': 'Request sent.',
  'accommodation.withdrawn': 'Request withdrawn and erased.',
  'accommodation.failed': 'Saving failed. Try again.',
  'accommodations.title': 'Disability support',
  'accommodations.intro': 'Your organization\'s disability referent, and the accommodation needs your learners shared with you (Qualiopi, indicator 26). This is health data: only administrators see it, and a learner can withdraw their request at any time, which erases it.',
  'accommodations.requests': 'Accommodation requests',
  'accommodations.empty': 'No request. Your learners can send one from “My account”.',
  'accommodations.open': 'Handle',
  'accommodations.saved': 'Request saved.',
  'accommodations.saveFailed': 'Saving failed. Try again.',
  'accommodations.sentOn': 'Request sent or edited on {{date}}',
  'accommodations.response': 'What is put in place',
  'accommodations.responseHelp': 'The learner reads this answer on “My account”. Say what changes for them, nothing more.',
  'accommodations.markHandled': 'Request handled',
  'accommodations.handledOn': 'Handled on {{date}}',
  'accommodations.status.pending': 'To handle',
  'accommodations.status.handled': 'Handled',
  'accommodations.column.learner': 'Learner',
  'accommodations.column.needs': 'Need',
  'accommodations.column.updatedAt': 'Since',
  'accommodations.column.status': 'Status',
  'accommodations.column.actions': 'Actions',
  'accommodations.referent.title': 'Disability referent',
  'accommodations.referent.help': 'The person your learners can turn to. Their name and contact show on the learners\' “My account” page.',
  'accommodations.referent.name': 'Name',
  'accommodations.referent.contact': 'Contact (email or phone)',
  'accommodations.referent.saved': 'Referent saved.',
  'complaints.title': 'Complaints',
  'complaints.intro': 'Requests, complaints and reports received by your organization, and how they were handled. Visible to administrators only.',
  'complaints.empty': 'No entry for these filters.',
  'complaints.export': 'Export (CSV)',
  'complaints.open': 'Handle',
  'complaints.saved': 'Complaint updated',
  'complaints.created': 'Complaint saved',
  'complaints.saveFailed': 'The complaint could not be saved.',
  'complaints.responseHelp': 'The answer given, for the record: it is not sent to the learner.',
  'complaints.respondedOn': 'Answered on {{date}}',
  'complaints.resolvedOn': 'Resolved on {{date}}',
  'complaints.receivedFrom': 'Received on {{date}} from {{author}} ({{origin}})',
  'complaints.categoryPlaceholder': 'Choose the type',
  'complaints.author.none': 'No linked author',
  'complaints.category.question': 'Question',
  'complaints.category.pedagogical': 'Pedagogical',
  'complaints.category.technical': 'Technical',
  'complaints.category.administrative': 'Administrative',
  'complaints.category.report': 'Report (violence, harassment, discrimination)',
  'complaints.category.other': 'Other',
  'complaints.status.open': 'Open',
  'complaints.status.inProgress': 'In progress',
  'complaints.status.resolved': 'Resolved',
  'complaints.origin.contactForm': 'help center',
  'complaints.origin.manual': 'entered manually',
  'complaints.column.receivedAt': 'Received on',
  'complaints.column.category': 'Type',
  'complaints.column.status': 'Status',
  'complaints.column.origin': 'Origin',
  'complaints.column.author': 'Author',
  'complaints.column.subject': 'Subject',
  'complaints.column.message': 'Message',
  'complaints.column.response': 'Answer given',
  'complaints.column.respondedAt': 'Answered on',
  'complaints.column.resolvedAt': 'Resolved on',
  'complaints.column.actions': 'Actions',
  'complaints.filter.allStatuses': 'All statuses',
  'complaints.filter.allCategories': 'All types',
  'complaints.new.button': 'Enter a complaint',
  'complaints.new.title': 'Enter a complaint',
  'complaints.new.description': 'A complaint received outside the app: letter, phone, meeting.',
  'complaints.new.submit': 'Save the complaint',
  'contact.category': 'Type of request',
  'contact.category.help': 'A report (violence, harassment, discrimination) is read only by your organization\'s administrators, never by your trainers.',
  'common.routing.organizations': 'Organizations',
  'common.routing.trial-requests': 'Trial requests',
  'common.routing.billing': 'Billing',
  'common.routing.trainer-capabilities': 'Trainer permissions',
  'common.routing.webhooks': 'Webhooks',
  'common.routing.sso': 'SSO authentication',
  'theme.dark': 'Dark mode',
  'theme.light': 'Light mode',
  'common.logout': 'Logout',
  'common.users': 'Users',
  'common.learners': 'Learners',
  'common.group': 'Group',
  'common.groups': 'Groups',
  'common.description': 'Description',
  'common.files': 'Files',
  'common.administration': 'Administration',
  'nav.group.training': 'Training',
  'nav.group.learners': 'Learners',
  'common.menu': 'Menu',
  'file-upload.success': 'File uploaded successfully.',
  'file-upload.failed': 'File upload failed.',
  'no.files': 'No files.',
  'start-by-uploading-a-file-using-the-button-below': 'Start by uploading a file using the button below.',
  'common.email': 'Email address',
  'common.username': 'Username',
  'common.firstname': 'First name',
  'common.lastname': 'Last name',
  'common.role': 'Role',
  'role.Admin': 'Administrator',
  'role.Formateur': 'Trainer',
  'role.User': 'Learner',
  'role.SuperAdmin': 'Platform operator',
  'account.title': 'My account',
  'account.identity.title': 'Identity',
  'account.identity.description': 'Your first and last name, as they appear in the app and on your certificates.',
  'account.identity.saved': 'Your details are saved.',
  'account.profile.title': 'My profile',
  'account.profile.organization': 'Organization',
  'account.profile.lastConnection': 'Last sign-in',
  'account.error.nameRequired': 'First and last name are required.',
  'account.error.nameTooLong': 'First and last name are 100 characters at most.',
  'account.error.impersonation': 'You are viewing this account on behalf of its owner: it cannot be changed.',
  'account.error.currentPassword': 'The current password is incorrect.',
  'account.error.noLocalPassword': 'This account signs in without a password: there is none to change.',
  'account.error.generic': 'Saving failed. Please try again.',
  'password.tooShort': 'At least 8 characters.',
  'account.password.title': 'Password',
  'account.password.description': 'Changing your password signs you out of your other devices. This session stays open.',
  'account.password.current': 'Current password',
  'account.password.new': 'New password',
  'account.password.submit': 'Change password',
  'account.password.saved': 'Your password has been changed.',
  'account.preferences.title': 'Preferences',
  'account.preferences.description': 'Language and appearance of the app on this device.',
  'account.preferences.theme': 'Theme',
  'account.preferences.theme.light': 'Light',
  'account.preferences.theme.dark': 'Dark',
  'account.preferences.theme.system': 'System',
  'contact.title': 'Need help?',
  'contact.recipient.admins': 'Your message goes to your organization\'s administrators.',
  'contact.recipient.support': 'Your message goes to Studeva support.',
  'contact.subject': 'Subject',
  'contact.message': 'Message',
  'contact.send': 'Send',
  'contact.sent': 'Your request has been sent. We will reply by email.',
  'contact.attachment.label': 'Screenshot (optional)',
  'contact.attachment.choose': 'Attach a screenshot',
  'contact.attachment.remove': 'Remove the screenshot',
  'contact.attachment.hint': 'PNG or JPEG, 1 MB at most.',
  'contact.attachment.tooLarge': 'The screenshot is over 1 MB.',
  'contact.attachment.invalidType': 'The screenshot must be a PNG or JPEG image.',
  'contact.error.subjectRequired': 'Enter a subject.',
  'contact.error.subjectTooLong': 'The subject is 150 characters at most.',
  'contact.error.messageRequired': 'Write your message.',
  'contact.error.messageTooLong': 'The message is 5,000 characters at most.',
  'contact.error.tooMany': 'Too many requests in a short time. Try again in a few minutes.',
  'contact.error.sendFailed': 'Sending failed. Please try again in a moment.',
  'tour.next': 'Next',
  'tour.prev': 'Previous',
  'tour.done': 'Done',
  'tour.progress': '{{current}} of {{total}}',
  'tour.unavailable': 'This screen could not be presented. Please try again in a moment.',
  'help.title': 'Help center',
  'help.intro': 'Each tour opens the screen it covers and walks you through it, step by step, on the real interface.',
  'help.tours.title': 'Guided tours',
  'help.tours.empty': 'No tour is available for your role yet.',
  'help.tour.start': 'Start the tour',
  'help.tour.startNamed': 'Start the tour: {{name}}',
  'help.contact.title': 'A question?',
  'help.contact.support': 'Write to support',
  'help.contact.admins': 'Write to my administrators',
  'common.routing.help': 'Help center',
  'tours.dashboard.title': 'Dashboard',
  'tours.dashboard.description': 'Where your learners stand, and what needs action.',
  'tours.dashboard.summary.title': 'Overall progress',
  'tours.dashboard.summary.body': 'The share of completed modules, the number of learners enrolled in a session, and the split between completed, incomplete, not started and not yet open, counted per learner and per module.',
  'tours.dashboard.report.title': 'PDF report',
  'tours.dashboard.report.body': 'Download these figures as a PDF, for a team review or a funder.',
  'tours.dashboard.trend.title': 'Trend',
  'tours.dashboard.trend.body': 'Modules completed over 30, 90 or 180 days: the momentum behind today\'s snapshot.',
  'tours.dashboard.alerts.title': 'To do',
  'tours.dashboard.alerts.body': 'What needs action today: overdue sessions with learners to chase, deadlines coming up, enrolled learners who never started, sessions about to begin.',
  'tours.dashboard.help.title': 'Help center',
  'tours.dashboard.help.body': 'Always at the top of the screen: the guided tours of each screen, and the form to ask a question.',
  'tours.modules.title': 'Modules',
  'tours.modules.description': 'Import your SCORM content and keep an eye on its storage.',
  'tours.modules.storage.title': 'Storage',
  'tours.modules.storage.body': 'The space your modules use, against your plan\'s quota.',
  'tours.modules.import.title': 'Import a module',
  'tours.modules.import.body': 'Give the module a title, choose its package below, then click “Import”: it is checked, then made available to your paths. If it fails, the reason shows here and the file stays chosen: click “Import” again to retry.',
  'tours.modules.dropzone.title': 'Drop the package',
  'tours.modules.dropzone.body': 'Drag the .zip here, or click to choose it. A file that is not a zip, or too heavy, is refused right away. During the upload, a bar shows the progress and the time left, and “Cancel” stops it; then the module is extracted and checked.',
  'tours.modules.search.title': 'Search',
  'tours.modules.search.body': 'Find a module by its title, regardless of accents or capitals.',
  'tours.modules.filters.title': 'Filter by status',
  'tours.modules.filters.body': 'Show only ready modules, those still processing, or those whose import failed.',
  'tours.modules.list.title': 'Your modules',
  'tours.modules.list.body': 'Every imported module, to preview as learners will see it, or to delete. Below the table: “Previous” and “Next” to change pages, and the number of rows per page.',
  'tours.sessions.title': 'Sessions',
  'tours.sessions.description': 'Build learning paths and enrol your learners.',
  'tours.sessions.new.title': 'New session',
  'tours.sessions.new.body': 'Expand the “Training sheet” if needed (objectives, prerequisites, audience, methods, assessment, accessibility, contact), which the learner reads on the path screen; with at least one objective, tick “Mandatory entry positioning” so each learner rates themselves on the objectives before opening a module. Pick the path\'s modules, their opening dates and, if needed, the module to complete before each one — with a minimum score. Group them into chapters if needed ("Start a chapter here"). For each module, say whether it can be retaken once completed, and which score then counts: the best, the last or the average. Choose what the certificate requires: every module completed, each one passed, or a minimum score on each, then its template — the organization\'s default one, or another of its certificate templates. Give it free tags to find it again (press Enter after each one). Name the trainers who run it, among the trainer and administrator accounts you can see. Finally add the participants, one by one or by group, and confirm with "Create".',
  'tours.sessions.search.title': 'Search',
  'tours.sessions.search.body': 'Find a session by its name or by the title of one of its modules, regardless of accents or capitals.',
  'tours.sessions.filters.title': 'Filters',
  'tours.sessions.filters.body': 'Narrow the list to active or archived sessions, then, with the next filter, to those whose path includes a given module, or — if you can see groups — that have at least one learner from a group, or, once a tag exists, that carry it, or, once a trainer is assigned, that they run. Filters combine.',
  'tours.sessions.list.title': 'Your sessions',
  'tours.sessions.list.body': 'Each session with its modules, trainers, participants and tags. Click its name to open its page: settings, path, participants and results. Below the table: “Previous” and “Next” to change pages, and the number of rows per page.',
  'tours.users.title': 'Users and learners',
  'tours.users.description': 'Find, invite and export your organization\'s accounts.',
  'tours.users.search.title': 'Search',
  'tours.users.search.body': 'Search by name, email, username, company or department; filter by group or progress.',
  'tours.users.add.title': 'Add or import',
  'tours.users.add.body': 'Invite someone by email, or create a learner without email with "Username and password"; import several from a CSV file in either mode. Company and department are optional, in the form as in the file ("societe" and "service" columns). Confirm with "Create" or "Import": an invitation is emailed, or the sign-in details are shown once, to copy or print with "Download the sheet".',
  'tours.users.export.title': 'Export',
  'tours.users.export.body': 'Get the list on screen as a CSV, filters included.',
  'tours.users.table.title': 'The list',
  'tours.users.table.body': 'Everyone\'s company, department, role, last sign-in and status. Click an email address to open the person\'s profile, tick rows to add them to a group at once.',
  'tours.groups.title': 'Groups',
  'tours.groups.description': 'Gather learners to enrol them together.',
  'tours.groups.search.title': 'Search',
  'tours.groups.search.body': 'Find a group by its name or description, regardless of accents or capitals.',
  'tours.groups.new.title': 'New group',
  'tours.groups.new.body': 'A group brings learners together — a team, a site, a cohort — to enrol them in a session in one click. Name it, tick its members, then "Create".',
  'tours.groups.list.title': 'Your groups',
  'tours.groups.list.body': 'Each group and its member count, to edit or delete from the row\'s menu. Below the table: “Previous” and “Next” to change pages, and the number of rows per page.',
  'tours.certificates.title': 'Certificates',
  'tours.certificates.description': 'Manage the certificate templates handed out at the end of a path.',
  'tours.certificates.template.title': 'The template',
  'tours.certificates.template.body': 'The template name, as shown when choosing it for a path, then the certificate text, logo and background. The words between braces are filled in for each learner.',
  'tours.certificates.preview.title': 'Preview',
  'tours.certificates.preview.body': 'Generate a sample certificate to check the result before saving.',
  'tours.reminders.title': 'Email reminders',
  'tours.surveyEditor.title': 'Satisfaction survey',
  'tours.surveyEditor.description': 'The questions asked to learners before their certificate.',
  'tours.surveyEditor.intro.title': 'How it works',
  'tours.surveyEditor.intro.body': 'The survey is offered to each learner who finished a path, right before their certificate. They can skip it: the certificate stays downloadable. Results, without names, are read on each session\'s page.',
  'tours.surveyEditor.questions.title': 'The questions',
  'tours.surveyEditor.questions.body': 'For each one: its label, and a rating from 1 to 5 or free text. A single rated question is the “overall satisfaction”: it makes the satisfaction rate. The arrows change the order, the bin removes.',
  'tours.surveyEditor.add.title': 'Add',
  'tours.surveyEditor.add.body': 'Adds a question at the bottom of the list, 15 at most.',
  'tours.surveyEditor.save.title': 'Save',
  'tours.surveyEditor.save.body': 'Nothing changes for learners until you click here. Answers already given keep the labels they read.',
  'tours.documents.title': 'Documents',
  'tours.documents.description': 'The documents handed to learners, and the proof they received them.',
  'tours.documents.intro.title': 'Handing out documents',
  'tours.documents.intro.body': 'Qualiopi asks you to show that each trainee received the internal rules, the programme and the training terms (indicator 9). The documents uploaded here show on the learner\'s path screen, where they declare they read them.',
  'tours.documents.new.title': 'Add a document',
  'tours.documents.new.body': '“Add a document”: choose a PDF of 10 MB at most, give it a title, pick its path or “Every path”, tick “To accept before starting” if needed, then “Upload the document”. A document to accept locks the learner\'s modules until they read it, unless they already started.',
  'tours.documents.list.title': 'Follow the delivery',
  'tours.documents.list.body': 'Each row says which path the document is for and how many learners read it; that number opens the list of acknowledgements with their date, to export as CSV. The icons download the document, edit its settings (then “Save”) or archive it: learners no longer see it, its acknowledgements stay.',
  'tours.quality.title': 'Continuous improvement',
  'tours.quality.description': 'The improvement action log and the quality risk register.',
  'tours.quality.intro.title': 'The improvement loop',
  'tours.quality.intro.body': 'Qualiopi asks you to show what you do with feedback (indicator 32) and, since V10, to analyse the risks to the quality of your services. Only administrators see this screen: it builds on complaints and dropouts.',
  'tours.quality.tabs.title': 'Two registers',
  'tours.quality.tabs.body': '“Improvement actions”: what is decided from feedback, and its effect. “Quality risks”: what could degrade your trainings, from most to least severe.',
  'tours.quality.export.title': 'Export',
  'tours.quality.export.body': 'Downloads the register shown as CSV, with all its columns: what the auditor asks for.',
  'tours.quality.new.title': 'Add',
  'tours.quality.new.body': 'An action: pick its origin, describe the finding and the decision, the owner and the due date, then “Save the action”. A risk: describe it, rate its likelihood and impact from 1 to 3, the mitigation, then “Save the risk”.',
  'tours.quality.list.title': 'Follow up',
  'tours.quality.list.body': '“Open” on a row: move the status forward, record an action\'s measured effect (the completion date is noted automatically), or review a risk\'s rating, then “Save”. Nothing is deleted: a cancelled action or a closed risk stays for the audit.',
  'tours.accommodations.title': 'Disability support',
  'tours.accommodations.description': 'The disability referent and the learners\' accommodation needs.',
  'tours.accommodations.intro.title': 'Welcoming people with disabilities',
  'tours.accommodations.intro.body': 'Qualiopi asks for an identified referent and for accommodation needs to be taken into account (indicator 26). These needs are health data: only administrators see them, never trainers.',
  'tours.accommodations.referent.title': 'The referent',
  'tours.accommodations.referent.body': 'Enter the name and contact of your disability referent, then “Save”. They show on each learner\'s “My account” page, next to their request.',
  'tours.accommodations.list.title': 'The requests',
  'tours.accommodations.list.body': 'Each learner can describe what they need, after giving their consent. “Handle” opens the request: write what is put in place, tick “Request handled”, then “Save”. The learner reads your answer; if they edit their request, it goes back to “to handle”. If they withdraw it, it disappears.',
  'tours.complaints.title': 'Complaints',
  'tours.complaints.description': 'The register of requests, complaints and reports, and how they were handled.',
  'tours.complaints.intro.title': 'The register',
  'tours.complaints.intro.body': 'Every request a learner sends from their help center lands here, with the type they chose. Only administrators see it: a report of violence, harassment or discrimination must never reach a trainer. This is the trace Qualiopi asks for (indicators 31 and 12).',
  'tours.complaints.filters.title': 'Filter',
  'tours.complaints.filters.body': 'By status (open, in progress, resolved) and by type. Reports show in red in the list.',
  'tours.complaints.export.title': 'Export',
  'tours.complaints.export.body': 'Downloads the displayed entries as CSV, filters included, with the dates received, answered and resolved: what the auditor asks for.',
  'tours.complaints.new.title': 'Enter a complaint',
  'tours.complaints.new.body': 'For a complaint received otherwise (letter, phone, meeting): choose its type, enter the subject and message, then “Save the complaint”.',
  'tours.complaints.list.title': 'Handle',
  'tours.complaints.list.body': '“Handle” opens the entry: read the message, correct its type, change its status, write the answer given, then “Save”. The first answer date and the resolution date are recorded automatically. The answer is not sent to the learner: reply through your usual channels.',
  'tours.reminders.description': 'Automatically nudge learners who have not finished.',
  'tours.reminders.cadence.title': 'Reminder schedule',
  'tours.reminders.cadence.body': 'Turn reminders on, then set the delay before the first one, the interval between two (3 days minimum), how many at most (1 to 10) and the sending hour. Only learners of an active path who have not finished are reminded.',
  'tours.reminders.message.title': 'Message sent',
  'tours.reminders.message.body': 'The subject and body of the reminder. The variables listed under the message (first name, module title, link…) are filled in for each learner.',
  'tours.reminders.digest.title': 'Completed paths digest',
  'tours.reminders.digest.body': 'Independent from reminders: tick the box so all administrators receive, every morning around 7 a.m., the list of paths completed since the previous digest, with each learner\'s name.',
  'tours.reminders.convocation.title': 'Enrollment convocation',
  'tours.reminders.convocation.body': 'On by default: every learner enrolled in a path receives an email with its name, dates, estimated duration and the link to open it. The sending date is kept and exported in reports ("Convocation sent on" column): your proof of information for Qualiopi. Untick and save to stop sending it.',
  'tours.reminders.test.title': 'Send me a test',
  'tours.reminders.test.body': 'Sends the message as it is on screen — even before saving — to you only, so you can check how it looks.',
  'tours.reminders.save.title': 'Save',
  'tours.reminders.save.body': 'Nothing applies until you save, digest included. Reminders then go out at most once a day, at the chosen sending hour and at the pace set above.',
  'tours.sso.title': 'SSO authentication',
  'tours.sso.description': 'Let your users sign in with their company account.',
  'tours.sso.intro.title': 'SSO',
  'tours.sso.intro.body': 'Your users sign in with their company account: Entra ID, Google Workspace, Okta, OpenID Connect or SAML.',
  'tours.sso.master.title': 'Master switch',
  'tours.sso.master.body': 'Turns SSO sign-in on or off for the whole organization. It applies right away, without saving. When off, no SSO button shows on the sign-in screen, but configurations are kept.',
  'tours.sso.picker.title': 'Provider to configure',
  'tours.sso.picker.body': 'Pick the provider whose settings you want to see. This choice saves nothing; the line below lists the providers already configured.',
  'tours.sso.provider.title': 'Provider settings',
  'tours.sso.provider.body': 'Whether it is on, the label of its sign-in button, the credentials your provider gives you (the secret is never shown again) and the allowed email domains. Once saved, the card shows the callback address to declare with your provider; “Delete” erases the configuration and its secret.',
  'tours.sso.save.title': 'Save',
  'tours.sso.save.body': 'Each provider is saved with its own button. To turn it on, its required fields must be filled in — and, for Google or a multi-organization Entra, at least one domain.',
  'tours.billing.title': 'Billing',
  'tours.billing.description': 'Follow what your plan costs and subscribe to a tier.',
  'tours.billing.month.title': 'Month shown',
  'tours.billing.month.body': 'A learner is counted once per contract year, and billing never blocks a session. The month picked here only changes the estimate shown.',
  'tours.billing.estimate.title': 'The month\'s estimate',
  'tours.billing.estimate.body': 'The amount for the month, the learners counted and the seats left in your tier, the month\'s active learners and those leaving the count within 3 months.',
  'tours.billing.plan.title': 'Your tier',
  'tours.billing.plan.body': 'Before subscribing: the four tiers, each with its learner capacity and its price excluding VAT. Once subscribed, this card shows your tier, its next billing date and, if any, the scheduled change (lower tier, switch to monthly) or the end date of a canceled subscription. If Studeva manages your plan, it says so: there is then nothing to pick.',
  'tours.billing.term.title': 'Monthly or upfront',
  'tours.billing.term.body': 'Monthly, with no commitment; upfront, the year paid in advance with two months free. The offer prices follow this choice.',
  'tours.billing.subscribe.title': 'Subscribe',
  'tours.billing.subscribe.body': '“Subscribe” opens Stripe\'s secure payment page: address, VAT number, card and acceptance of the terms of sale. Your tier switches on as soon as Stripe confirms the payment, usually within seconds.',
  'tours.billing.manage.title': 'Manage my subscription',
  'tours.billing.manage.body': 'Opens Stripe\'s secure space: change tier (an upgrade applies at once, prorated; a downgrade or a switch to monthly, at the period end), cancel at the period end, change card, download your invoices. Your changes show here within seconds.',
  'tours.billing.profile.title': 'Billing details',
  'tours.billing.profile.body': 'Company name, VAT number, address and billing email, with their own “Save” button. After a first subscription, they are managed in Stripe\'s secure space, with your invoices.',
  'tours.billing.history.title': 'History',
  'tours.billing.history.body': 'The last 12 months, recomputed with your current plan. Read-only.',
  'tours.billingPlatform.title': 'Platform billing',
  'tours.billingPlatform.description': 'Read what each organization uses and brings in.',
  'tours.billingPlatform.month.title': 'Month shown',
  'tours.billingPlatform.month.body': 'Pick the month to read. The whole screen is read-only: nothing to change, nothing to save.',
  'tours.billingPlatform.counters.title': 'Count by organization',
  'tours.billingPlatform.counters.body': 'For each organization: learners counted, active this month, registered learners, plan and estimated revenue — with the total at the bottom.',
  'tours.billingPlatform.storage.title': 'Storage by organization',
  'tours.billingPlatform.storage.body': 'Space used, the plan\'s cap and the number of modules; a badge flags organizations over their cap.',
  'tours.organizations.title': 'Organizations',
  'tours.organizations.description': 'Create client organizations and manage their members.',
  'tours.organizations.create.title': 'Create an organization',
  'tours.organizations.create.body': 'Opens a form: name, URL identifier (lowercase letters, digits and dashes) and administrator. The organization exists only once you confirm with “Create”; the administrator then gets an invitation email.',
  'tours.organizations.list.title': 'Organizations',
  'tours.organizations.list.body': 'Each organization, with its URL identifier, member count, plan and status: active or suspended.',
  'tours.organizations.actions.title': 'Actions',
  'tours.organizations.actions.body': '“Update” changes the name, the identifier (renaming breaks links already shared, hence a confirmation), the status or the plan — billing mode (subscription, or managed by Studeva with its internal note) and tier —, to be saved. “Members” invites, changes a role (right away), opens a member\'s session or removes them — which deletes their account. “Suspend” and “Activate” apply immediately. “Delete” is only possible on an empty organization.',
  'tours.trialRequests.title': 'Trial requests',
  'tours.trialRequests.description': 'Open or reject the space of organizations that asked for a trial.',
  'tours.trialRequests.intro.title': 'Pending requests',
  'tours.trialRequests.intro.body': 'Organizations that confirmed their email address and are waiting for their space.',
  'tours.trialRequests.list.title': 'The list',
  'tours.trialRequests.list.body': 'For each request: the organization, the requester and their contact details, their role and the confirmation date.',
  'tours.trialRequests.actions.title': 'Approve or reject',
  'tours.trialRequests.actions.body': '“Approve” creates the space right away, on the free plan, and sends the activation email — without confirmation. “Reject” asks for an optional reason, included in the email sent to the requester.',
  'helpDemo.banner': 'Demo: made-up data, nothing is saved.',
  'helpDemo.back': 'Back to the help center',
  'helpDemo.inert': 'Nothing starts in the demo.',
  'helpDemo.player.placeholder': 'The module content shows here, full screen.',
  'helpDemo.session.group': 'North branch',
  'helpDemo.session.survey.question': 'Overall, are you satisfied with this training?',
  'helpDemo.session.survey.module': 'Life-saving gestures',
  'helpDemo.session.survey.commentLabel': 'What could be improved?',
  'helpDemo.session.survey.comment': 'More role plays, please.',
  'helpDemo.session.tag': 'Autumn cohort',
  'helpDemo.path.name': 'Onboarding new starters',
  'sheet.title': 'Training sheet',
  'sheet.help': 'What the learner needs to know before and during the training. Everything is optional; what is filled in shows on the path screen. Objectives can also appear on the certificate with the {{objectives}} variable.',
  'sheet.objectives': 'Objectives',
  'sheet.objectives.help': 'One objective per line, {{count}} at most.',
  'sheet.prerequisites': 'Prerequisites',
  'sheet.audience': 'Target audience',
  'sheet.teachingMethods': 'Teaching methods',
  'sheet.assessmentMethods': 'Assessment methods',
  'sheet.accessibility': 'Accessibility',
  'sheet.contact': 'Contact',
  'sheet.positioning': 'Mandatory entry positioning',
  'sheet.positioning.help': 'Before opening a module, each learner rates themselves on the objectives above and states their expectations. They can rate themselves again at the end. A learner who already started is not blocked.',
  'sheet.positioning.needsObjectives': 'Enter at least one objective to ask for a positioning.',
  'path.sheet.title': 'About this training',
  'helpDemo.path.sheet.objective1': 'Know the site safety rules',
  'helpDemo.path.sheet.objective2': 'Know who to ask during the first week',
  'helpDemo.path.sheet.audience': 'Employees who joined less than a month ago',
  'helpDemo.path.sheet.prerequisites': 'None',
  'helpDemo.path.sheet.contact': 'training@example.com',
  'helpDemo.path.basics': 'The basics',
  'helpDemo.path.further': 'Going further',
  'helpDemo.path.welcome.title': 'Welcome',
  'helpDemo.path.welcome.description': 'An introduction to the organization and your path.',
  'helpDemo.path.essentials.title': 'Essential moves',
  'helpDemo.path.essentials.description': 'What to know from day one.',
  'helpDemo.path.cases.title': 'Case studies',
  'helpDemo.path.cases.description': 'Real situations, to practise.',
  'helpDemo.path.assessment.title': 'Final assessment',
  'helpDemo.path.assessment.description': 'A quiz to complete the path.',
  'tours.path.title': 'A path screen',
  'tours.path.description': 'Follow its steps and see why one is locked — on a demo path.',
  'tours.path.header.title': 'The path',
  'tours.path.header.body': 'Its name, its status (to start, in progress, finished), your progress (steps done, estimated time left), how you move through it — in a set order, or freely — and the date it was assigned to you. “My courses”, above, takes you back home. Once the path is done — and its certificate condition met, if it sets one — the certificate is downloaded here; otherwise the screen says what is missing.',
  'tours.path.sheet.title': 'About this training',
  'tours.path.sheet.body': 'Click to expand what the organization wrote about the training: its objectives, prerequisites, target audience, methods, assessment, accessibility and contact. The block only shows when it was filled in.',
  'tours.path.documents.title': 'Documents',
  'tours.path.documents.body': 'The rules, programme or booklet the organization hands you: “Download” to read them, then “I have read it”. Those marked “To read before starting” lock the modules until you do.',
  'tours.path.positioning.title': 'Positioning',
  'tours.path.positioning.body': 'If the training asks for it, position yourself before you start: “Position myself”, rate yourself from 1 to 5 on each objective, state your expectations if you wish, then “Send”. The modules then open. At the end of the path, “Rate myself again” offers to measure your progress, with no obligation.',
  'tours.path.steps.title': 'The steps',
  'tours.path.steps.body': 'Every step, grouped by chapter with its progress. Each one says where it stands: done (with score and time spent), in progress, or locked — with the reason: a date to wait for, or a module to finish or pass. “Let\'s go”, “Pick up again” or “Start over” opens the module; “Start over” only shows if the path lets you redo it.',
  'tours.path.focus.title': 'Your next step',
  'tours.path.focus.body': 'The module to pick up now: its length, pass mark, your score, and the button to resume it. If no step is open, the panel says why; once the path is done, it says so too. Your progress saves itself while you follow the module: nothing to save.',
  'tours.player.title': 'The module player',
  'tours.player.description': 'Follow a module, leave it, pick it up later — on a demo.',
  'tours.player.exit.title': 'Leave',
  'tours.player.exit.body': 'Takes you back to “My trainings” at any time. Your progress is kept: you will pick up where you left off.',
  'tours.player.header.title': 'Where you are',
  'tours.player.header.body': 'The path you are following and, if it has several modules, this one\'s rank (“Step 2 of 4”).',
  'tours.player.content.title': 'The module',
  'tours.player.content.body': 'The module shows here. Your progress saves itself as you go: nothing to save. At the end of a chapter, a screen offers the next one; at the end of the module, it confirms it, and a button takes you back to “My trainings”.',
  'tours.preview.title': 'Previewing a module',
  'tours.preview.description': 'Play a module as a learner would, without saving anything — on a demo.',
  'tours.preview.exit.title': 'Back to modules',
  'tours.preview.exit.body': 'Takes you back to the module list, where previews are opened from.',
  'tours.preview.header.title': 'Preview',
  'tours.preview.header.body': 'The module being played, marked “Preview”: nothing you do here is saved, neither progress nor score.',
  'tours.preview.content.title': 'The module',
  'tours.preview.content.body': 'The module plays here exactly as it does for a learner, without enrolment or tracking. Nothing to save.',
  'tours.webhooks.title': 'Webhooks',
  'tours.webhooks.description': 'Notify your system when a learner completes a module or a path.',
  'tours.webhooks.intro.title': 'Webhooks',
  'tours.webhooks.intro.body': 'Whenever a module, or a whole path, is completed, Studeva calls your system with the learner, the path, the module and its result.',
  'tours.webhooks.endpoint.title': 'The destination',
  'tours.webhooks.endpoint.body': 'Your system\'s HTTPS address, reachable from the Internet, and the switch. When off, nothing new is queued; calls already waiting fail and are retried on schedule — they go out again if you switch it back on in time, and are given up after about 31 h.',
  'tours.webhooks.save.title': 'Save',
  'tours.webhooks.save.body': 'Nothing applies until you save. The first save generates the signing secret, shown only once.',
  'tours.webhooks.secret.title': 'The secret',
  'tours.webhooks.secret.body': 'It signs every call; your system recomputes the signature to make sure it comes from Studeva. Copy it as soon as it shows. “Replace the secret” generates a new one, and the old one stops signing at once.',
  'tours.webhooks.deliveries.title': 'Latest deliveries',
  'tours.webhooks.deliveries.body': 'Each call, its status, its last response and, if waiting, its next attempt. A refused call is retried after 1 min, 10 min, 1 h, 6 h then 24 h, and given up after that. The refresh button reloads the log.',
  'tours.webhooks.test.title': 'Send a test',
  'tours.webhooks.test.body': 'Queues a test call to the active destination, to check that it answers and that the signature verifies. It goes out as soon as possible.',
  'tours.trainerCapabilities.title': 'Trainer permissions',
  'tours.trainerCapabilities.description': 'Choose what trainers can do in your organization.',
  'tours.trainerCapabilities.intro.title': 'The Trainer role',
  'tours.trainerCapabilities.intro.body': 'These settings apply to every trainer in the organization. Administrators are never limited: you cannot remove your own permissions.',
  'tours.trainerCapabilities.domains.title': 'Permissions, by area',
  'tours.trainerCapabilities.domains.body': 'Tick what trainers can do with paths, modules, learners and statistics. Some permissions require others: those are ticked along automatically, and unticking a permission removes the ones that depend on it. A withdrawn permission also hides the matching menu entries and buttons. Only the PDF report is blocked by the server: the hidden CSV export reuses data already on screen.',
  'tours.trainerCapabilities.save.title': 'Save',
  'tours.trainerCapabilities.save.body': 'Nothing changes until you save. Then access is refused from the trainer\'s next action; their screen updates the next time it loads.',
  'tours.branding.title': 'Customization',
  'tours.branding.description': 'Dress the app in your organization\'s colours.',
  'tours.branding.identity.title': 'Identity',
  'tours.branding.identity.body': 'The app name, your logos for light and dark backgrounds, and the favicon.',
  'tours.branding.colors.title': 'Colours',
  'tours.branding.colors.body': 'The primary colour dresses navigation and buttons; its ink must stay readable (contrast of at least 4.5:1), otherwise saving is refused. Clear an ink to have it computed.',
  'tours.branding.save.title': 'Save',
  'tours.branding.save.body': 'Your settings apply to the whole organization as soon as you save.',
  'tours.dashboard.tiles.title': 'Key figures',
  'tours.dashboard.tiles.body': 'Pass rate, average score and average time spent, across all your learners.',
  'tours.dashboard.range.title': 'Period',
  'tours.dashboard.range.body': 'Choose to look at the last 30, 90 or 180 days.',
  'tours.modules.actions.title': 'Preview, replace, rename and delete',
  'tours.modules.actions.body': 'The play button opens the module as learners will see it, without counting as an attempt. The arrows replace its content with a new version of the zip: you first see what it changes (sessions, learners finished or in progress), then confirm with “Replace content”; learner tracking is kept. The pencil renames it: type the new title, then “Save”. The bin deletes it, once you confirm: its files go with it.',
  'tours.sessions.trainers.title': 'Trainers',
  'tours.sessions.trainers.body': 'Who runs each session. Trainers are chosen in the session form, among the trainer and administrator accounts you can see, and saved with it ("Create" or "Save"). The assignment is informative: it doesn\'t change what anyone can see or do.',
  'tours.sessions.status.title': 'Status',
  'tours.sessions.status.body': 'An active session is open to its participants; once archived — from its edit form — it leaves their home screen without losing their results.',
  'tours.sessions.actions.title': 'Actions',
  'tours.sessions.actions.body': 'Edit the path, dates, opening conditions, retake rules, certificate template, trainers and participants — remember to "Save" —, duplicate it for a new group — the copy keeps everything but dates and learners, which you then choose and save —, preview its first module, or delete the session — a confirmation tells how many learners lose their tracking.',
  'tours.users.filters.title': 'Filters',
  'tours.users.filters.body': 'Narrow the list to a group, or to a progress state: not started, in progress, completed.',
  'tours.users.select.title': 'Selection',
  'tours.users.select.body': 'Tick rows, or the whole page, to add several people to a group, or remove them, at once.',
  'tours.users.actions.title': 'Account actions',
  'tours.users.actions.body': 'See the person\'s sessions; as an admin, edit the account — then "Update" —, delete it, "Resend validation email" to an account still pending, sign in as them to help, or, for a username learner, "Reset the password" and give them the new one.',
  'tours.groups.actions.title': 'Actions',
  'tours.groups.actions.body': 'Edit a group\'s name and members — then "Save" —, or delete it: its members keep their accounts and enrolments.',
  'tours.certificates.variables.title': 'Variables',
  'tours.certificates.variables.body': 'These words in braces are replaced by the learner\'s name, the course, the date or the score when the certificate is generated.',
  'tours.certificates.logo.title': 'Logo',
  'tours.certificates.logo.body': 'The logo printed on the certificate, when it should differ from the app\'s.',
  'tours.certificates.background.title': 'Background',
  'tours.certificates.background.body': 'A one-page PDF in your brand style, on which the text is printed.',
  'tours.certificates.email.title': 'Notify the learner',
  'tours.certificates.email.body': 'Tick the box so that learners of the paths using this template receive an email, with a link to their path, as soon as their certificate is available. Remember to save.',
  'tours.certificates.save.title': 'Save',
  'tours.certificates.save.body': 'Nothing applies before saving. Certificates are generated on each download: the saved template also applies to those of already completed paths that use it.',
  'tours.branding.misc.title': 'Other settings',
  'tours.branding.misc.body': 'The footer text and the language offered by default to your users.',
  'tours.account.title': 'My account',
  'tours.account.description': 'Your details, your password and your preferences.',
  'tours.account.profile.title': 'Your profile',
  'tours.account.profile.body': 'Your email, role, organization and last sign-in. The email cannot be changed here.',
  'tours.account.identity.title': 'First and last name',
  'tours.account.identity.body': 'Correct them, then click "Save": they are used everywhere, certificates included.',
  'tours.account.password.title': 'Password',
  'tours.account.password.body': 'Enter the current one, then the new one twice, and confirm with "Change password". The eye on each field shows what you type. Your other devices are signed out.',
  'tours.account.preferences.title': 'Preferences',
  'tours.account.preferences.body': 'Language and theme apply on click, with nothing to save, on this device.',
  'tours.account.accommodation.title': 'Need an accommodation',
  'tours.account.accommodation.body': 'If you need an adjustment to follow your trainings, describe it here, tick the consent box, then “Send my request”. Only your organization\'s administrators read it. You also see your disability referent and the organization\'s answer; “Edit” or “Withdraw my request” at any time.',
  'tours.home.title': 'My learning space',
  'tours.home.description': 'Find your courses and see where to pick up.',
  'tours.home.dashboard.title': 'Dashboard',
  'tours.home.dashboard.body': 'Come back here at any time, from any screen of your space: your courses, your progress and where to pick up.',
  'tours.home.search.title': 'Search',
  'tours.home.search.body': 'Find a training or a module by name, accents aside. Shortcut: Ctrl K (⌘ K on Mac); arrow keys move through the results, Enter opens the selected one.',
  'tours.home.hero.title': 'Your progress',
  'tours.home.hero.body': 'How many courses you have completed, and which one to pick up next: the button takes you straight there.',
  'tours.home.paths.title': 'Your paths',
  'tours.home.paths.body': 'A path chains several modules, sometimes grouped into chapters. Open it to see its steps, their duration, your score and the progress of each chapter. Once everything is done, the “Certificate” button shows on the card — or, if the path requires a pass or a score, what is still missing.',
  'tours.home.courses.title': 'Your courses',
  'tours.home.courses.body': 'A single-module course starts straight from its card. Once completed, "Start over" starts it again for a new attempt, if your trainer allows it. The “Certificate” button shows once it is earned; otherwise the card says what is missing.',
  'tours.home.menu.title': 'Your account',
  'tours.home.menu.body': 'Your account, your preferences and the help center: the guided tours of your space, and the form to write to us. The terms of use and the privacy policy are there too.',
  'status.disabled': 'Disabled',
  'common.lastConnection': 'Last connection',
  'status.active': 'Active',
  'status.pending': 'Pending',
  'common.search': 'Search',
  'common.add': 'Add',
  'common.export': 'Export',
  'common.refresh': 'Refresh',
  'export.truncated': 'Export limited to the first {{max}} rows out of {{total}}: narrow the filters to get them all.',
  'common.status': 'Status',
  'common.action': 'Actions',
  'common.update': 'Update',
  'common.delete': 'Delete',
  'common.impersonate': 'View their workspace',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'good.update.user': 'User update was successful.',
  'bad.update.user': 'Failed to update user.',
  'update.user': 'Update user',
  'input.required.message': 'This field is required',
  'input.email.message': 'Enter your email address!',
  'common.cancel': 'Cancel',
  'good.delete.user': 'User was successfully deleted.',
  'bad.delete.user': 'Failed to delete user.',
  'delete.user': 'Delete user',
  'delete.user.first-message': 'Deleting this user will delete all their statistics and access.',
  'delete.second-message': 'Are you sure?',
  'good.add.user': 'User was successfully added.',
  'bad.add.user': 'Failed to add user.',
  'demo.learnerLimit': 'Your demo space already has 10 learners, its maximum. To add more, disable a learner account or move to a paid plan.',
  'add.user.emailUsed': 'This email address is already used by an account.',
  'create.user': 'Create user',
  'common.create': 'Create',
  'common.home': 'Home',
  'common.mechanics': 'Mechanics',
  'quiz.result.title': 'Quiz result',
  'quiz.result.questions': 'Correct answers',
  'quiz.result.failure': 'You failed the quiz',
  'quiz.result.success': 'You passed the quiz',
  'quiz.restart': 'Restart',
  'time.left': 'Time left',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Correct answer',
  'quiz.answer.incorrect': 'Incorrect answer',
  'common.validate': 'Validate',
  'common.finish': 'Finish',
  'messages-history': 'Message history',
  'no.history.infos': 'No history',
  'reset.password.success': 'A reset email has been sent',
  'bad.reset.message': 'Failed to send the reset email.',
  'bad.server-login.message': 'Unable to contact the server!',
  'common.loading': 'Loading',
  'reset.password': 'Reset Password',
  'common.submit': 'Submit',
  'login.return-message': 'Return to login page',
  'input.password': 'Enter your password!',
  'password.not-match.message': 'Passwords do not match',
  'new.password.success': 'Your password has been updated',
  'new.password': 'New Password',
  'new.password.description': 'Enter your new password',
  'common.password': 'Password',
  'common.rowsPerPage': 'Rows per page',
  'common.confirm-password': 'Confirm Password',
  'logout.pending': 'Signing out',
  'login.microsoft': 'Login with Microsoft',
  'impossible.read.token': 'Unable to read token!',
  'connection.successful': 'Connection successful!',
  'connection.failed': 'Connection failed!',
  'common.login': 'Login',
  'password.forgot': 'Forgot password?',
  'login.identifier': 'Email address or username',
  'login.identifier.placeholder': 'you@example.com or username',
  'login.username.forgot': 'Signing in with a username? Ask your institution for a new password.',
  'password.show': 'Show password',
  'common.register': 'Register',
  'access.denied.message': 'You do not have access rights to this page.',
  'input.password-confirm': 'Confirm your password',
  'good.register.message': 'Registration was successful.',
  'bad.register.message': 'Registration failed.',
  'finish.register': 'Finish registration',
  'password.confirm': 'Confirm your password',
  'good-order.message': 'The correct order is:',
  'reset.password.description': 'Enter your email address to reset your password',
  'common.login.description': 'Enter your email and password below to login to your account',
  'common.or': 'or',
  'login.tagline': 'Learn.\nProgress.\nGet certified.',
  'login.tagline.sub': 'Your courses, progress and certificates, all in one place.',
  'login.magic-link.cta': 'Get a sign-in link',
  'login.magic-link.description': 'Enter your email: we\'ll send you a sign-in link, no password needed.',
  'login.magic-link.submit': 'Send the link',
  'login.magic-link.sent.title': 'Check your inbox',
  'login.magic-link.sent.description': 'If an account matches {{email}}, a sign-in link has just been sent there. It expires in 15 minutes and works only once.',
  'login.magic-link.resend': 'Resend the link',
  'login.password.cta': 'Sign in with a password',
  'magic-link.checking': 'Signing you in',
  'magic-link.checking.description': 'We are checking your sign-in link.',
  'magic-link.failed.title': 'Invalid or expired link',
  'magic-link.failed.description': 'This link has already been used or has expired. Request a new one from the login page.',
  'magic-link.request-new': 'Request a new link',
  'finish.register.message': 'Hi {{firstName}} {{lastName}}, choose the password for the {{email}} account to activate it.',
  'invitation.expired': 'Invitation expired',
  'invitation.expired.message': 'This invitation link has expired. Ask your workspace administrator for a new invitation.',
  'invitation.invalid': 'Invalid invitation',
  'invitation.invalid.message': 'This invitation link is invalid or has already been used. If your account is already active, sign in.',
  'good.reset.message': 'The reset email has been sent successfully.',
  'create.account': 'Create Account',
  'create.account.description': 'Enter your information to create an account',
  'create.account.success': 'Your account has been created successfully',
  'first.name': 'First Name',
  'last.name': 'Last Name',
  'new.password.message': 'Enter your email address and new password',
  'common.ok': 'Valid',
  'common.game-mechanics': 'Game mechanics',
  'quiz-mechanisms.available': 'Available quiz mechanics',
  'common.welcome': 'Welcome',
  'no.content': 'No content',
  'common.confirm': 'Confirm',
  'common.noResults': 'No results with these filters.',
  'common.noResultsFor': 'No results for "{{query}}".',
  'common.allStatuses': 'All statuses',
  'common.reset': 'Reset',
  'common.empty': 'No data',
  'desc.sort': 'Click to sort in descending order',
  'asc.sort': 'Click to sort in ascending order',
  'cancel.sort': 'Click to cancel sorting',
  'your.informations': 'Your information',
  'you.are': 'You are',
  'your.email': 'Your email',
  'token.creation.message': 'Your token was created on:',
  'token.expiration.message': 'Your token will expire on:',
  'common.hello': 'Hello',
  'user.management': 'User management',
  'add.user': 'Add user',
  'bad.connection': 'Unable to connect',
  'bad.connection.message': 'The password and email entered do not match. Please check your information and log in again.',
  'access.refused.accountDisabled': 'Your account is disabled. Please contact your organization’s administrator.',
  'access.refused.organizationSuspended': 'Access to your organization is suspended. Please contact your organization’s administrator.',
  'common.more': 'More',
  'common.breadcrumb': 'Breadcrumb',
  'sidebar.toggle': 'Show or hide the menu',
  'sidebar.mobile.title': 'Menu',
  'sidebar.mobile.description': 'Back-office navigation.',
  'common.close': 'Close',
  'common.quiz-mechanics': 'Quiz mechanics',
  'import.user': 'Import user',
  'good.import.user': 'User import was successful.',
  'bad.import.user': 'Failed to import user.',
  'bad.import.user.none': 'No account was created: every row was rejected.',
  'warn.import.user.partial': 'Partial import: {{count}} row(s) rejected.',
  'download.template': 'Download template',
  'click.to.upload': 'Click to upload',
  'common.import': 'Import',
  'import.csv.help': 'CSV file with columns {{headers}} (semicolon separator). Learners receive an invitation email.',
  'import.csv.groupHelp': 'Optional "groupe" column: the group is created if it does not exist yet.',
  'import.csv.parsed': '{{count}} row(s) detected in “{{file}}”.',
  'import.preview.valid': '{{count}} row(s) ready to import.',
  'import.preview.none': 'No importable row in this file.',
  'import.preview.skipped': '{{count}} row(s) will be skipped:',
  'import.preview.checking': 'Checking for addresses already in use…',
  'import.check.failed': 'Could not check addresses already in use: they will be validated on import.',
  'import.submit': 'Import {{count}} row(s)',
  'import.report.created': '{{count}} account(s) created and invited by email.',
  'import.report.partial': '{{count}} account(s) created and invited by email, {{failed}} row(s) rejected.',
  'import.report.none': 'No account created: all {{count}} row(s) in the file were rejected.',
  'import.report.line': 'Row',
  'import.report.reason': 'Reason',
  'import.error.empty': 'The CSV file is empty.',
  'import.error.badHeader': 'Invalid headers. Expected: email ; firstName ; lastName.',
  'import.error.MISSING_FIELDS': 'Missing required field',
  'import.error.INVALID_EMAIL': 'Invalid email',
  'import.error.DEMO_LEARNER_LIMIT': 'Demo full: 10 learners at most',
  'import.error.DUPLICATE_IN_FILE': 'Duplicate in file',
  'import.error.EMAIL_ALREADY_USED': 'Email already used',
  'import.error.CREATION_FAILED': 'Creation failed',
  'common.settings': 'Customization',
  'unknow.error': 'Unknown error!',
  'common.dashboard': 'Dashboard',
  'dashboard.noStatistics': 'Your organization does not give you access to statistics.',
  'dashboard.subtitle': 'What needs action, then where your learners stand.',
  'dashboard.alerts.title': 'Needs attention',
  'impersonate.user': 'View {{name}}\'s workspace',
  'bad.impersonate.user': 'Failed to open this user\'s workspace.',
  'impersonate.user.preview': 'You will see the application exactly as {{name}} sees it: their sessions, their modules, their progress. Their own session stays open on their side, and any module you open is not recorded for them.',
  'impersonate.user.not-read-only': 'This is not a read-only mode: apart from SCORM progress, every action taken from their workspace is really carried out and recorded in their name.',
  'impersonate.user.return-hint': 'A banner at the top of the screen will let you return to your account at any time.',
  'impersonate.user.confirm': 'Open their workspace',
  'impersonate.started': 'You are now viewing {{name}}\'s workspace',
  'impersonate.banner.message': 'You are viewing {{name}}\'s workspace',
  'impersonate.banner.warning': 'Their progress is not recorded, but your other actions are.',
  'impersonate.banner.exit': 'Back to my account',
  'impersonate.exit.failed': 'Could not restore your admin session. Please log in again.',
  'account.validate': 'Validate account',
  'account.validate.confirmation': 'Please confirm your account by clicking the button below.',
  'valid.account.success': 'Your account has been successfully validated!',
  'valid.account.failed': 'Account validation failed. Please try again later.',
  'resend.email.success': 'Validation email sent successfully',
  'resend.email.failed': 'Failed to send validation email',
  'resend.email': 'Resend validation email',
  'scorm.player.title': 'SCORM Module',
  'scorm.player.loading': 'Loading module...',
  'scorm.player.error': 'Error loading SCORM module',
  'scorm.progress.saved': 'Progress saved',
  'scorm.progress.save.error': 'Error saving progress',
  'common.statistics': 'Statistics',
  'common.completionStatus': 'Completion Status',
  'common.successStatus': 'Success Status',
  'common.score': 'Score',
  'common.completedAt': 'Completed At',
  'common.totalTime': 'Total Time',
  'status.completed': 'Completed',
  'status.archived': 'Archived',
  'sessions.name': 'Session',
  'user.sessions.title': 'User sessions',
  'user.sessions.subtitle': 'Sessions and progress for {{name}}',
  'user.sessions.empty': 'This user is not enrolled in any session.',
  'user.sessions.progress': 'Progress',
  'user.sessions.view': 'View sessions',
  'user.lastConnection.never': 'Never',
  'user.progress.label': 'Progress',
  'user.progress.all': 'All progress',
  'user.progress.notStarted': 'Never started',
  'user.progress.inProgress': 'In progress',
  'user.progress.completed': 'Completed',
  'status.incomplete': 'Incomplete',
  'status.not_attempted': 'Not Started',
  'status.unknown': 'Unknown',
  'status.passed': 'Passed',
  'status.failed': 'Failed',
  'login.sso': 'SSO Login',
  'login.sso.with': 'Continue with {{provider}}',
  'sso.error': 'SSO login error',

  // Navigation & common
  'common.modules': 'Modules',
  'common.module': 'Module',
  'common.sessions': 'Sessions',
  'common.session': 'Session',
  'common.allSessions': 'All sessions',
  'common.name': 'Name',
  'common.organizations': 'Organizations',
  'billing.title': 'Billing',
  'billing.help': 'A learner is counted once per contract year, on their first login. Admin accounts never count. This counter observes: it never blocks a session.',
  'billing.month': 'Month',
  'billing.monthlyActive': 'Monthly active',
  'billing.yearlyActive': 'Learners trained',
  'billing.registered': 'Registered learners',
  'billing.freeTier': 'Free plan',
  'billing.freeTier.within': 'Included ({{learners}}/{{limit}})',
  'billing.freeTier.over': 'Beyond free plan',
  'billing.devis.over': 'Beyond {{threshold}} learners: let\'s talk',
  'billing.total': 'Total',
  'billing.empty': 'No organization.',
  'billing.neverBlocked': 'Your tier sets the price. Going over its capacity blocks no learner: you are invited to change tier.',
  'billing.amountDue': 'This month',
  'billing.amountDue.free': 'Included in the free plan ({{limit}} learners trained per year).',
  'billing.amountDue.overFree': 'Beyond the free plan, nothing is charged until you pick a plan: at this pace the year would cost {{amount}}.',
  'billing.amountDue.upfront': 'Year paid upfront ({{amount}}): nothing is due this month.',
  'billing.amountDue.monthly': 'The tier price, billed monthly. Cancellable at any time.',
  'billing.managed.title': 'Plan managed by Studeva',
  'billing.managed.body': 'Your plan is agreed directly with Studeva: there is no tier to pick and no online payment, no learner cap, and every feature is open. To change it, reach out to your Studeva contact.',
  'billing.managed.hint': 'No cap, no restriction: your plan is managed by Studeva.',
  'billing.plan.title': 'Your tier',
  'billing.offers.title': 'Choose a tier',
  'billing.offers.capacity': 'Up to {{count}} learners',
  'billing.offers.perMonth': 'excl. VAT / month',
  'billing.offers.perYear': 'excl. VAT / year',
  'billing.offers.subscribe': 'Subscribe',
  'billing.offers.subscribeTo': 'Subscribe to tier {{tier}}',
  'billing.offers.redirecting': 'Opening the payment…',
  'billing.offers.note': 'VAT added. Payment happens on Stripe\'s secure page; your tier switches on as soon as the payment is confirmed.',
  'billing.offers.error': 'The payment page could not open. Try again in a moment.',
  'billing.offers.error.subscribed': 'A subscription is already running for your organization. Reload the page to see it.',
  'billing.offers.error.impersonation': 'Only an administrator of the organization, signed in with their own account, can subscribe.',
  'billing.offers.error.unavailable': 'Online payment is temporarily unavailable. Write to us at contact@studeva.fr.',
  'billing.checkout.pending.title': 'Payment being confirmed',
  'billing.checkout.pending.body': 'Stripe is confirming your payment: your tier switches on within seconds. You can stay on this page.',
  'billing.checkout.confirmed.title': 'Your subscription is active',
  'billing.checkout.confirmed.body': 'Your tier is in place. Stripe sends you your invoices by email.',
  'billing.checkout.slow.title': 'The confirmation is taking longer than expected',
  'billing.checkout.slow.body': 'Stripe is still processing your payment. Reload the page in a few minutes; if your tier still does not show, write to us at contact@studeva.fr.',
  'billing.checkout.canceled.title': 'Payment canceled',
  'billing.checkout.canceled.body': 'Nothing was charged. You can subscribe whenever you like.',
  'billing.subscription.current': 'Tier {{tier}} · {{term}}',
  'billing.subscription.renews': 'Next billing date: {{date}}.',
  'billing.subscription.cancels': 'Subscription canceled: your tier stays active until {{date}}, then the space returns to demo mode.',
  'billing.subscription.scheduled': 'On {{date}}, switching to tier {{tier}} ({{term}}).',
  'billing.paymentFailed': 'The last payment of your subscription failed. Stripe will retry over the next days: update your card to keep your tier. Without payment, your space will return to demo mode.',
  'billing.paymentFailed.update': 'Update my card',
  'billing.portal.manage': 'Manage my subscription',
  'billing.portal.invoices': 'Invoices and billing details',
  'billing.portal.opening': 'Opening…',
  'billing.portal.profile': 'Your billing details (address, VAT number, email) are managed with your invoices, in Stripe\'s secure space.',
  'billing.offers.error.noCustomer': 'No subscription has been taken yet: there is nothing to manage for now.',
  'billing.offers.error.managed': 'Your plan is managed by Studeva: write to us at contact@studeva.fr for your invoices and billing details.',
  'billing.mode.SELF_SERVICE': 'Subscription taken by the organization',
  'billing.mode.MANAGED': 'Managed by Studeva',
  'billing.mode.SELF_SERVICE.help': 'The organization picks and pays for its own tier.',
  'billing.mode.MANAGED.help': 'Outside subscriptions: no learner cap, no locked feature, and nothing removes it on its own. For migrated clients, quotes and partners.',
  'billing.tier.FREE': 'Demo',
  'billing.tier.S': 'S',
  'billing.tier.M': 'M',
  'billing.tier.L': 'L',
  'billing.tier.XL': 'XL',
  'billing.tier.CUSTOM': 'Managed by Studeva',
  'billing.tier.FREE.help': 'Demo mode: every feature, up to 10 learners.',
  'billing.tier.S.help': 'Up to 50 learners — €99/month, €990/year.',
  'billing.tier.M.help': 'Up to 100 learners — €189/month, €1,890/year.',
  'billing.tier.L.help': 'Up to 250 learners — €449/month, €4,490/year.',
  'billing.tier.XL.help': 'Up to 500 learners — €849/month, €8,490/year.',
  'billing.tier.CUSTOM.help': 'Beyond 500 learners: custom quote.',
  'billing.tier.CUSTOM.notice': 'Beyond 500 learners, pricing is on a quote basis — get in touch.',
  'billing.term.field': 'Payment',
  'billing.term.UPFRONT': 'Upfront',
  'billing.term.MONTHLY': 'Monthly',
  'billing.term.UPFRONT.help': 'The year paid upfront: two months free (10 months paid for 12). Non-refundable.',
  'billing.term.MONTHLY.help': 'Cancellable at any time; billing stops at the end of the current month. No commitment.',
  'billing.learnerCount': 'Counted learners',
  'billing.billedTier': 'Tier {{tier}}',
  'billing.placesRemaining': 'Tier {{tier}} — {{places}} included places left',
  'billing.overCapacity': 'Your {{learners}} learners go over the capacity of tier {{tier}}: move to tier {{needed}}. Nothing is blocked meanwhile.',
  'billing.overCapacity.quote': 'Your {{learners}} learners go over the capacity of tier {{tier}} and of the top tier: get in touch for a quote. Nothing is blocked meanwhile.',
  'billing.overCapacityShort': 'Over: {{needed}}',
  'billing.quote': 'Custom quote',
  'billing.capacityAlert.change': 'Change tier',
  'billing.capacityAlert.contact': 'Contact us to change tier',
  'billing.placesShort': '{{places}} included places left',
  'billing.leavingSoon': 'Leaving within 3 months',
  'billing.leavingSoon.help': 'Learners who will drop off the counter within 3 months unless re-enrolled or returning.',
  'billing.yearly.base': 'Yearly base',
  'billing.yearly.commitmentAmount': 'Committed year',
  'billing.yearly.tolerated': 'Covered learners',
  'billing.yearly.overage': 'Estimated adjustment',
  'billing.yearly.overage.monthly': 'Not applicable: your learners are billed as they go.',
  'billing.yearly.estimate': 'At this pace, the contract year will cost {{amount}}.',
  'billing.profile.title': 'Billing details',
  'billing.profile.help': 'Used as-is on your invoices. An empty field never blocks anything.',
  'billing.profile.companyName': 'Company name',
  'billing.profile.vatNumber': 'VAT number',
  'billing.profile.addressLine1': 'Address',
  'billing.profile.addressLine2': 'Address line 2',
  'billing.profile.postalCode': 'Postal code',
  'billing.profile.city': 'City',
  'billing.profile.country': 'Country',
  'billing.profile.billingEmail': 'Billing email',
  'billing.profile.saved': 'Billing details saved.',
  'billing.profile.error': 'Billing details not saved.',
  'billing.history.title': 'History',
  'billing.history.help': 'Last twelve months. Amounts are recomputed with your current plan: real invoices will come with online payment.',
  'billing.history.month': 'Month',
  'billing.history.counted': 'Counter entries',
  'billing.history.amount': 'Amount',
  'billing.plan': 'Plan',
  'billing.estimatedRevenue': 'Estimated revenue',
  // Storage (#180): measured everywhere, capped on the free plan only.
  'storage.title': 'Storage',
  'storage.size': 'Size',
  'storage.used': 'Used',
  'storage.quota': 'Quota',
  'storage.usedOfQuota': '{{used}} / {{quota}}',
  'storage.remaining': '{{remaining}} left.',
  'storage.moduleCount': '{{count}} module(s)',
  'storage.noQuota': 'Your plan does not impose any storage quota.',
  'storage.overQuota': 'You have exceeded the storage included in the free plan. Your modules remain available to your learners; only new imports are refused until you free up space or move to a paid plan.',
  'storage.overQuota.badge': 'Over quota',
  'storage.uploadRefused': 'Import refused, not enough space: you are using {{used}} of the {{quota}} included in the free plan, and this module needs {{incoming}} more. Delete a module you no longer need, or move to a paid plan to lift the quota.',
  'storage.platform.title': 'Storage per organization',
  'storage.platform.help': 'What the platform actually hosts. The quota only applies to organizations on the free plan: elsewhere we measure without refusing anything.',
  'organization.create': 'Create an organization',
  'organization.create.help': 'The administrator receives an invitation email to finalize their account.',
  'organization.slug': 'Identifier (URL)',
  'organization.members': 'Members',
  'organization.suspended': 'Suspended',
  'organization.suspend': 'Suspend',
  'organization.activate': 'Activate',
  'organization.admin.email': 'Administrator email',
  'organization.edit.title': 'Edit organization',
  'organization.edit.required': 'Name and slug are required.',
  'organization.edit.success': 'Organization updated.',
  'organization.edit.failed': 'Update failed (slug already used or invalid?).',
  'organization.edit.planFailed': 'Organization saved, but the plan could not be changed.',
  'organization.edit.planSubscribed': 'Organization saved, but its tier is paid on Stripe: only its admin can change it, from “Manage my subscription”.',
  'organization.edit.slug.help': 'Changing the slug changes the organization\'s login URL.',
  'organization.edit.billingMode': 'Billing mode',
  'organization.edit.billingNote': 'Internal note',
  'organization.edit.billingNote.help': 'Contract, payment method… Seen by Studeva only, never by the organization.',
  'organization.edit.tier': 'Plan',
  'organization.delete.title': 'Delete organization',
  'organization.delete.confirm': 'Confirm deletion of "{{name}}"? This action is irreversible.',
  'organization.delete.success': 'Organization deleted.',
  'organization.delete.failed': 'Deletion failed.',
  'organization.delete.notEmpty': 'Remove all members first: a non-empty organization cannot be deleted.',
  'organization.delete.default': 'The default organization cannot be deleted.',
  'organization.members.title': 'Members — {{name}}',
  'organization.members.empty': 'No members.',
  'organization.member.invite.title': 'Invite a member',
  'organization.member.invite.required': 'Email, first name and last name are required.',
  'organization.member.invite.submit': 'Invite',
  'organization.member.invite.success': 'Invitation sent.',
  'organization.member.invite.failed': 'Invitation failed.',
  'organization.member.invite.emailUsed': 'This email is already in use.',
  'organization.member.role.success': 'Role updated.',
  'organization.member.role.failed': 'Role change failed.',
  'organization.member.role.lastAdmin': 'Not possible: this is the organization\'s last administrator.',
  'organization.member.role.hint': 'The change takes effect for the person at their next sign-in.',
  'organization.member.impersonate': 'Open their session',
  'organization.member.impersonate.hint': 'Opens this organization\'s back-office under their identity. Any action there is really carried out in their name.',
  'organization.member.remove': 'Remove',
  'organization.member.remove.success': 'Member removed.',
  'organization.member.remove.failed': 'Removal failed.',
  'good.add.organization': 'The organization was created and its administrator invited.',
  'bad.add.organization': 'Failed to create the organization.',
  'common.title': 'Title',
  'common.version': 'Version',
  'common.save': 'Save',
  'common.remove': 'Remove',
  'common.choose': 'Choose…',
  'common.participants': 'Participants',

  // White-label / branding
  'branding.identity': 'Application identity',
  'branding.appName': 'Application name',
  'branding.logo': 'Logo',
  'branding.noLogo': 'No logo',
  'branding.favicon': 'Favicon',
  'branding.noFavicon': 'No favicon',
  'branding.colorsTypography': 'Colors & typography',
  'branding.primaryColor': 'Primary color',
  'branding.accentColor': 'Secondary color',
  'branding.accentColor.hint': 'Hover backgrounds, active rows, badges. Enter the one from your brand guidelines.',
  'branding.primaryForeground': 'Text on the primary color',
  'branding.accentForeground': 'Text on the secondary color',
  'branding.foreground.hint': 'Leave empty to automatically use the most readable ink.',
  'branding.suggest': 'Readable ink',
  'branding.accent.fromPrimary': 'Derive from primary',
  'branding.logo.light': 'Logo for light backgrounds',
  'branding.logo.dark': 'Logo for dark backgrounds',
  'branding.logo.darkHint': 'The dark version is optional: without it, the light logo is shown on both themes. Add it if your logo is monochrome, otherwise it will disappear for learners using the dark theme.',
  'branding.contrast.title': 'Contrast of the chosen colors',
  'branding.contrast.text': 'text {{ratio}}:1',
  'branding.contrast.textOk': 'readable',
  'branding.contrast.textFail': 'unreadable text, saving will be refused',
  'branding.contrast.surface': 'fill {{ratio}}:1',
  'branding.contrast.surfaceOk': 'stands out from the page',
  'branding.contrast.surfaceFail': 'blends into the page',
  'branding.contrast.invalid': '{{label}}: colour not recognised',
  'branding.preview': 'Preview',
  'branding.preview.button': 'Primary button',
  'branding.preview.hover': 'Hovered row',
  'branding.starter': 'Suggestions:',
  'branding.logo.constraints': 'PNG or JPEG, {{max}} KB max per file.',
  'branding.favicon.constraints': 'PNG, SVG or ICO, {{max}} KB max. Square, legible at 32 pixels.',
  'branding.typography.fixed': 'Typography is the platform\'s and cannot be customised: a freely chosen font is not necessarily available on your learners\' devices.',
  'branding.misc': 'Miscellaneous',
  'branding.footerText': 'Footer text',
  'branding.footerPlaceholder': 'Leave empty for a default footer',
  'branding.defaultLocale': 'Default language',
  'branding.imageTooLarge': 'Image too large (max {{max}} KB).',
  'branding.assetTooLarge': '{{asset}} too large (max {{max}} KB): replace it with a lighter image to save.',
  'branding.readError': 'Could not read the file.',
  'branding.saved': 'Configuration saved.',
  'branding.saveError': 'Save failed.',
  'branding.inkTooLow': '{{color}}: the text on it is unreadable (contrast below 4.5:1). Pick another ink, or clear it to have it computed.',

  // SCORM modules
  'modules.import.title': 'Import a SCORM module',
  'modules.package': 'Package (.zip)',
  'modules.list.title': 'Modules',
  'modules.empty': 'No module yet. Import a SCORM package.',
  'modules.titlePlaceholder': 'Module name',
  'modules.status.ready': 'Ready',
  'modules.status.processing': 'Processing…',
  'modules.status.failed': 'Failed',
  'modules.selectFile': 'Select a SCORM .zip file.',
  'modules.uploadFailed': 'Import failed',
  'modules.imported': 'Module imported.',
  'modules.upload.hint': 'SCORM package as a .zip, {{max}} maximum',
  'modules.upload.hintNoMax': 'SCORM package as a .zip',
  'modules.upload.processing': 'Extracting and checking the module…',
  'modules.upload.tooLarge': 'This package is over the maximum import size.',
  'modules.upload.network': 'The connection dropped during the upload. Check your network, then click “Import” again.',
  'modules.upload.cancelled': 'Upload cancelled.',
  'modules.refreshFailed': 'The module list could not be refreshed. Reload the page to update it.',
  'fileDrop.prompt': 'Drop a file here, or click to choose one',
  'fileDrop.selected': '{{name}} ({{size}})',
  'fileDrop.rejected.count': 'One file at a time.',
  'fileDrop.rejected.type': 'This file is not in the right format: {{extensions}} expected.',
  'fileDrop.rejected.size': 'This file weighs {{size}}, over the {{max}} maximum.',
  'upload.sending': 'Uploading… {{percent}}%',
  'upload.progress': 'Upload progress',
  'upload.bytes': '{{loaded}} of {{total}}',
  'upload.remaining.seconds': 'about {{count}} s left',
  'upload.remaining.minutes': 'about {{count}} min left',
  'upload.announce.uploading': 'Uploading the file.',
  'modules.deleted': 'Module deleted.',
  'modules.deleteFailed': 'Delete failed.',
  'modules.deleteTitle': 'Delete the module “{{name}}”?',
  'modules.deleteBody': 'Its files are erased with it: nothing can be recovered. A module used by a session cannot be deleted.',
  'modules.inUse': 'This module is used by {{sessions}}. Remove it from these sessions before deleting it.',
  'modules.inUseUnnamed': 'This module is used by at least one session. Remove it from its sessions before deleting it.',
  'modules.preview': 'Preview',
  'modules.replace.action': 'Replace content',
  'modules.replace.title': 'Replace the content of “{{name}}”',
  'modules.replace.intro': 'Upload the new version of the package (.zip). The module keeps your learners\' tracking, and nothing changes for them until you confirm.',
  'modules.replace.reviewIntro': 'Here is what the new version changes. Confirm to put it online, or cancel to keep the current one.',
  'modules.replace.upload': 'Upload',
  'modules.replace.confirm': 'Replace content',
  'modules.replace.done': 'Content replaced. Learner tracking is kept.',
  'modules.replace.failed': 'The replacement failed: the previous version stays online.',
  'modules.replace.sessions_one': 'Used in {{count}} session: {{names}}.',
  'modules.replace.sessions_other': 'Used in {{count}} sessions: {{names}}.',
  'modules.replace.noSession': 'Not used in any session.',
  'modules.replace.completed_one': '{{count}} learner has finished: their result and certificate are kept.',
  'modules.replace.completed_other': '{{count}} learners have finished: their results and certificates are kept.',
  'modules.replace.inProgress_one': '{{count}} learner is in progress: they will restart the module from the beginning, keeping their time and scores.',
  'modules.replace.inProgress_other': '{{count}} learners are in progress: they will restart the module from the beginning, keeping their time and scores.',
  'modules.replace.notStarted_one': '{{count}} enrolled learner has not started yet.',
  'modules.replace.notStarted_other': '{{count}} enrolled learners have not started yet.',
  'modules.replace.scos': 'Chapters: {{kept}} kept, {{added}} added, {{removed}} removed.',
  'modules.replace.noScoMatch_one': 'No chapter of the current version is found in the new one: the learner in progress restarts this module from zero. Check that it really is the same module.',
  'modules.replace.noScoMatch_other': 'No chapter of the current version is found in the new one: the {{count}} learners in progress restart this module from zero. Check that it really is the same module.',
  'modules.contentUpdatedAt': 'Content updated on {{date}}',
  'modules.rename.action': 'Rename',
  'modules.rename.title': 'Rename the module',
  'modules.rename.body': 'The new title shows everywhere: sessions, learner space and reports. Learner tracking does not change.',
  'modules.rename.done': 'Module renamed.',
  'modules.rename.failed': 'Renaming failed.',

  // Sessions (back-office)
  'sessions.create.title': 'Create a session',
  'sessions.namePlaceholder': 'Session name',
  'sessions.selectModule': '— Choose a module —',
  'sessionDetail.open': 'Open the page of {{name}}',
  'sessionDetail.edit': 'Edit',
  'sessionDetail.trainers.empty': 'No trainer assigned to this session.',
  'sessionDetail.back': 'Back to sessions',
  'sessionDetail.notFound': 'This session does not exist or is no longer available.',
  'sessionDetail.dates.range': 'From {{start}} to {{end}}',
  'sessionDetail.dates.from': 'From {{start}}',
  'sessionDetail.dates.until': 'Until {{end}}',
  'sessionDetail.dates.none': 'No start or end date',
  'sessionDetail.tags': 'Tags',
  'sessionDetail.info.title': 'Information',
  'sessionDetail.info.createdAt': 'Created on',
  'sessionDetail.info.minScore': 'minimum score {{score}} %',
  'sessionDetail.info.template': 'Certificate template',
  'sessionDetail.info.defaultTemplate': 'Default template',
  'sessionDetail.info.customTemplate': 'Custom template',
  'sessionDetail.kpis.title': 'Indicators',
  'sessionDetail.kpis.participants': 'Participants',
  'sessionDetail.path.empty': 'No module in this path.',
  'sessionDetail.path.prerequisite': 'Opens after “{{title}}”',
  'sessionDetail.path.prerequisiteScore': 'Opens after “{{title}}” with at least {{score}} %',
  'sessionDetail.path.completed': '{{completed}} / {{total}} completed',
  'sessionDetail.participants.title': 'Participants',
  'sessionDetail.participants.modules': 'Completed modules',
  'sessionDetail.participants.lastActivity': 'Last activity',
  'sessionDetail.participants.actions': 'Actions',
  'sessionDetail.kpis.dropoutRate': 'Dropout rate',
  'sessionDetail.kpis.dropoutMethod': 'Declared dropouts ÷ learners enrolled in the session',
  'sessionDetail.dropout.status': 'Dropped out',
  'sessionDetail.dropout.declare': 'Declare a dropout',
  'sessionDetail.dropout.cancel': 'Cancel the dropout',
  'sessionDetail.dropout.title': '{{name}} dropped out',
  'sessionDetail.dropout.description': 'The learner will no longer get reminders and leaves the late alerts. Their results stay. You can cancel the dropout if they resume.',
  'sessionDetail.dropout.reason.label': 'Dropout reason',
  'sessionDetail.dropout.reason.placeholder': 'Choose a reason',
  'sessionDetail.dropout.reason.personal': 'Personal reasons',
  'sessionDetail.dropout.reason.professional': 'Professional reasons',
  'sessionDetail.dropout.reason.health': 'Health',
  'sessionDetail.dropout.reason.content': 'Training content',
  'sessionDetail.dropout.reason.technical': 'Technical difficulties',
  'sessionDetail.dropout.reason.other': 'Other',
  'sessionDetail.dropout.note': 'Details (optional)',
  'sessionDetail.dropout.confirm': 'Declare the dropout',
  'sessionDetail.dropout.declared': 'Dropout declared',
  'sessionDetail.dropout.cancelled': 'Dropout cancelled',
  'sessionDetail.dropout.failed': 'The dropout could not be saved.',
  'sessionDetail.participants.empty': 'No participant in this state.',
  'sessionDetail.exports.csv': 'Results (CSV)',
  'sessionDetail.exports.pdf': 'PDF report',
  'sessionDetail.exports.questions': 'Question analysis',
  'attendance.single': 'Attendance statement',
  'attendance.batch': 'Attendance statements',
  'attendance.downloadFor': 'Attendance statement for “{{name}}”',
  'attendance.failed': 'The attendance statement could not be generated.',
  'common.routing.sessionDetail': 'Session page',
  'sessionDetail.results.loading': 'Loading the results…',
  'sessionDetail.results.failed': 'Could not load the session results.',
  'sessionDetail.results.retry': 'Try again',
  'sessions.startDate': 'Start (optional)',
  'sessions.endDate': 'End (optional)',
  'sessions.noUsers': 'No user.',
  'sessions.list.title': 'Sessions',
  'sessions.allModules': 'All modules',
  'sessions.empty': 'No session.',
  'sessions.nameRequired': 'Enter a name and a module.',

  // Multi-module paths (#139) and scheduled unlocking (#182)
  'sessions.path.title': 'Path modules',
  'sessions.path.count_one': '{{count}} module',
  'sessions.path.count_other': '{{count}} modules',
  'sessions.path.empty': 'No modules yet. Add one to build the path.',
  'sessions.path.add': 'Add',
  'sessions.path.required': 'A path must contain at least one module.',
  'sessions.path.prerequisite': 'Opens after',
  'sessions.path.prerequisite.none': 'no prerequisite',
  'sessions.path.prerequisite.previous': '{{title}} (previous)',
  'sessions.path.minScore': 'with a minimum score',
  'sessions.path.minScore.label': 'Minimum score to get on "{{title}}", as a percentage',
  'sessions.path.minScore.mastery': '(module pass mark: {{score}}%)',
  'sessions.path.minScore.noMastery': 'This module declares no pass mark: check that it reports a score, otherwise the next module will never open.',
  'sessions.path.retake.allow': 'Can be retaken once completed',
  'sessions.path.retention': 'Retained score',
  'sessions.path.retention.BEST': 'best score',
  'sessions.path.retention.LAST': 'last attempt',
  'sessions.path.retention.AVERAGE': 'average of attempts',
  'sessions.path.chapter.label': 'Chapter {{number}}',
  'sessions.path.chapter.title': 'Title of chapter {{number}}',
  'sessions.path.chapter.remove': 'Remove chapter {{number}}',
  'sessions.path.chapter.start': 'Start a chapter here',
  'sessions.path.chapter.default': 'New chapter',
  'sessions.path.chapter.titleRequired': 'Give each chapter a title.',
  'sessions.path.opensOn': 'Opens on',
  'sessions.path.reorder': 'Move {{title}} within the path',
  'sessions.path.remove': 'Remove {{title}} from the path',
  'sessions.path.stage.on_one': '{{count}} module on the same date',
  'sessions.path.stage.on_other': '{{count}} modules on the same date',
  'sessions.path.stage.immediate_one': '{{count}} module open from the start',
  'sessions.path.stage.immediate_other': '{{count}} modules open from the start',
  'sessions.path.stage.setDate': 'Stage opening date',
  'sessions.path.warn.loop': 'This module and its prerequisite wait for each other: neither would open. Pick another prerequisite.',
  'sessions.path.warn.afterEnd': 'This date falls after the path ends: the module would never open.',
  'sessions.path.warn.beforeStart': 'This date precedes the path start: the module will open when the path begins.',
  'sessions.path.warn.inProgress_one': 'This path has {{count}} enrolled learner. Changing its modules changes their progress: a learner who had completed it will go back to "in progress" and lose access to their certificate.',
  'sessions.path.warn.inProgress_other': 'This path has {{count}} enrolled learners. Changing its modules changes their progress: learners who had completed it will go back to "in progress" and lose access to their certificates.',
  'sessions.certificate.minScoreRequired': 'Enter the minimum score the certificate requires.',
  'sessions.certificate.noRetake': 'A module of this path cannot be retaken: a learner who fails it, or stays under the threshold, will never get the certificate.',
  'sessions.tags.label': 'Tags',
  'sessions.tags.placeholder': 'Add a tag, then press Enter',
  'sessions.tags.remove': 'Remove the tag {{tag}}',
  'sessions.tags.all': 'All tags',
  'sessions.tags.full': 'Up to 10 tags: remove one to add another',
  'sessions.tags.hint': 'To find your paths again: up to 10 tags, 40 characters each. They are shared across the organization, and keep the spelling of their first entry.',
  'sessions.certificate.label': 'Certificate condition',
  'sessions.certificate.COMPLETION': 'Every module completed',
  'sessions.certificate.SUCCESS': 'Every module passed',
  'sessions.certificate.SCORE': 'A minimum score on every module',
  'sessions.certificate.minScore': 'Minimum score, as a percentage',
  'sessions.certificate.hint': 'All modules must always be completed. With success, only modules that report one count; with a score, only those that report one. The score kept is the one chosen for each module.',
  'sessions.certificate.warn_one': 'This path has {{count}} enrolled learner. The certificate follows the current condition and scores: if they had already earned it, this change can take it away.',
  'sessions.certificate.warn_other': 'This path has {{count}} enrolled learners. The certificate follows the current condition and scores: those who had already earned it may lose it with this change.',
  'sessions.progression.label': 'Progression',
  'sessions.progression.free': 'Free',
  'sessions.progression.sequential': 'Sequential',
  'sessions.progression.free.hint': 'Learners take modules in any order they like.',
  'sessions.progression.sequential.hint': 'Each module opens once the previous one is completed. An opening date adds to this rule, it does not replace it.',

  // The path as the learner sees it (#139 / #182)
  'home.path.summary': '{{done}} / {{total}} modules completed',
  'home.path.opensOn': 'Available from {{date}}',
  'home.path.awaitingPrerequisite': 'It will open once you have completed "{{title}}"',
  'home.path.awaitingScore': 'Score at least {{score}}% on "{{title}}" to open it',
  'home.path.awaitingPrevious': 'Waiting for you once you finish the previous one',
  'positioning.entry.title': 'Before you start: position yourself',
  'positioning.entry.body': 'Say where you stand on each objective of the training, and what you expect from it. The modules open as soon as it is done.',
  'positioning.entry.action': 'Position myself',
  'positioning.exit.title': 'Measure your progress',
  'positioning.exit.body': 'You are done: where do you stand now on each objective? It is optional.',
  'positioning.exit.action': 'Rate myself again',
  'positioning.dialog.description': 'For each objective, from 1 (not at all) to 5 (completely): I can do it.',
  'positioning.dialog.needs': 'Your expectations or needs for this training (optional)',
  'positioning.dialog.later': 'Later',
  'positioning.dialog.submit': 'Send',
  'positioning.sent': 'Thank you, it is saved.',
  'positioning.failed': 'Sending failed. Try again.',
  'home.path.awaitingPositioning': 'It opens once you have positioned yourself on the objectives',
  'pathDocuments.title': 'Training documents',
  'pathDocuments.required': 'To read before starting',
  'pathDocuments.download': 'Download',
  'pathDocuments.acknowledge': 'I have read it',
  'pathDocuments.readOn': 'Read on {{date}}',
  'pathDocuments.acknowledgeFailed': 'Saving failed. Try again.',
  'pathDocuments.downloadFailed': 'The download failed.',
  'home.path.awaitingDocuments': 'It opens once you have read the training documents',
  'scorm.player.step': 'Step {{current}} of {{total}}',
  'sessions.created': 'Session created.',
  'sessions.createFailed': 'Creation failed.',
  'sessions.deleted': 'Session deleted.',
  'sessions.deleteFailed': 'Delete failed.',
  'sessions.duplicate': 'Duplicate',
  'sessions.duplicateTitle': 'Duplicate “{{name}}”',
  'sessions.duplicateBody': 'The copy keeps the modules, chapters, rules, training sheet, certificate, tags, trainers and documents. Dates and learners are not copied: you choose them next.',
  'sessions.duplicateName': 'Name of the copy',
  'sessions.duplicateDefaultName': '{{name}} (copy)',
  'sessions.duplicated': 'Session duplicated. Choose its dates and learners, then save.',
  'sessions.duplicateFailed': 'Duplication failed. Try again.',
  'sessions.deleteTitle': 'Delete the session “{{name}}”?',
  'sessions.deleteBody_one': '{{count}} enrolled learner loses their enrollment and tracking (progress, scores, time spent): nothing can be recovered. To only hide it from learners, archive it.',
  'sessions.deleteBody_other': '{{count}} enrolled learners lose their enrollment and tracking (progress, scores, time spent): nothing can be recovered. To only hide it from learners, archive it.',
  'sessions.deleteBodyEmpty': 'No learner is enrolled. Deleting it is permanent.',
  'sessions.new': 'New session',
  'sessions.update.title': 'Edit session',
  'sessions.updated': 'Session updated.',
  'sessions.updateFailed': 'Update failed.',
  'sessions.openModule': 'Open module',
  'sessions.participants.selectAll': 'Select all',
  'sessions.trainers.label': 'Trainers',
  'sessions.trainers.all': 'All trainers',
  'sessions.trainers.search': 'Search trainers',
  'sessions.participants.clear': 'Clear all',
  'sessions.participants.addGroup': 'Enrol a group:',
  'sessions.participants.search': 'Search participants',

  // User groups (#135)
  'groups.list.title': 'Groups',
  'groups.new': 'New group',
  'groups.empty': 'No group.',
  'groups.memberCount': 'Members',
  'groups.members': 'Members',
  'groups.membersSearch': 'Search members',
  'groups.create.title': 'Create a group',
  'groups.update.title': 'Edit group',
  'groups.namePlaceholder': 'Group name (e.g. Lyon City Council)',
  'groups.nameRequired': 'Enter a name.',
  'groups.nameUsed': 'A group already has this name.',
  'groups.created': 'Group created.',
  'groups.createFailed': 'Creation failed.',
  'groups.updated': 'Group updated.',
  'groups.updateFailed': 'Update failed.',
  'groups.deleted': 'Group deleted.',
  'groups.deleteFailed': 'Delete failed.',
  'groups.delete.title': 'Delete group',
  'groups.delete.message': 'Delete "{{name}}"? Its {{count}} members keep their accounts: only the grouping disappears.',
  'groups.none': 'No group',
  'groups.all': 'All groups',
  'groups.select': '— Choose a group —',
  'groups.bulk.selected': '{{count}} selected',
  'groups.bulk.selectPage': 'Select the whole page',
  'groups.bulk.add': 'Assign',
  'groups.bulk.remove': 'Remove',
  'groups.bulk.added': 'Users assigned to the group.',
  'groups.bulk.removed': 'Users removed from the group.',
  'groups.bulk.failed': 'Operation failed.',

  // Sessions (learner)
  'sessions.my.title': 'My sessions',
  'sessions.my.empty': 'Nothing on the horizon just yet.',
  'sessions.my.start': 'Let\'s go',

  // Learner home. We are talking to someone giving up their own time to learn,
  // not to a record: greet them by name and tell them what is waiting.
  // Written as English, not as a word-for-word rendering of the French — a
  // literal translation of a warm French line reads mawkish in English.
  'home.nav.label': 'Learning space navigation',
  'home.nav.dashboard': 'Dashboard',
  'learnerSearch.label': 'Search a course or module',
  'learnerSearch.placeholder': 'Search…',
  'learnerSearch.group.sessions': 'Courses',
  'learnerSearch.group.modules': 'Modules',
  'learnerSearch.progress': '{{pct}}% done',
  'learnerSearch.count_one': '{{count}} result',
  'learnerSearch.count_other': '{{count}} results',
  'learnerSearch.locked': 'Locked',
  'home.title': 'My trainings',
  'home.section.paths': 'Your learning paths',
  'duration.hours_one': '{{count}}h',
  'duration.hours_other': '{{count}}h',
  'duration.hoursMinutes': '{{hours}}h {{minutes}}',
  'duration.minutes_one': '{{count}} min',
  'duration.minutes_other': '{{count}} min',
  'duration.lessThanMinute': 'less than a minute',
  'home.meta.estimated': '{{duration}}',
  'home.meta.remaining': '{{duration}} left',
  'home.meta.spent': '{{duration}} spent',
  'home.meta.threshold': 'pass mark {{threshold}}',
  'home.assignedOn': 'Assigned on {{date}}',
  'home.section.courses': 'Your courses',
  'home.type.path_one': 'Path · {{count}} step',
  'home.type.path_other': 'Path · {{count}} steps',
  'home.type.course': 'Course',
  'home.stepsDone': '{{done}} / {{total}} steps completed',
  'home.nextStep': 'Next step:',
  'home.continue': 'Continue',
  'home.allStepsDone': 'Every step is completed.',
  'path.back': 'My courses',
  'path.steps.title': 'Steps',
  'path.chapter': 'Chapter {{number}} · {{title}}',
  'path.chapter.done': '{{done}} / {{total}} completed',
  'path.stepOf': 'Step {{position}} of {{total}}',
  'path.mode.sequential': 'Steps open one after another: finish the current one to unlock the next.',
  'path.mode.free': 'You can take the steps in any order you like.',
  'path.done.title': 'Path completed',
  'path.done.hint': 'Your certificate can be downloaded above. You may revisit any step as often as you like.',
  'path.notFound': 'This course is no longer available.',
  // The `_named` variants are the i18next `context`: with no usable first name
  // we greet plainly rather than render a gap-toothed "Good morning, !".
  'home.greeting.morning': 'Good morning',
  'home.greeting.morning_named': 'Good morning, {{name}}',
  'home.greeting.afternoon': 'Good afternoon',
  'home.greeting.afternoon_named': 'Good afternoon, {{name}}',
  'home.greeting.evening': 'Good evening',
  'home.greeting.evening_named': 'Good evening, {{name}}',
  // Situational line: only ever one, picked by `learnerFocus`.
  'home.focus.allDone': 'You are all done. Your certificates are ready to download below.',
  'home.focus.allDoneCertificatesPending': 'You are all done. Some certificates still wait on a condition: see below what is missing.',
  'home.focus.deadlineToday': 'Today is the last day to finish “{{session}}”.',
  'home.focus.deadline_one': 'You have {{count}} day left to finish “{{session}}”.',
  'home.focus.deadline_other': 'You have {{count}} days left to finish “{{session}}”.',
  'home.focus.resume': 'Pick up “{{session}}” where you left off.',
  'home.focus.start': '“{{session}}” is ready when you are.',
  'home.status.completed': 'Finished',
  'home.status.notStarted': 'Not started yet',
  'home.inProgress': 'In progress',
  'home.retake': 'Start over',
  'home.resume': 'Pick up again',
  'home.review': 'Review',
  'home.completedOn': 'Finished on',
  'home.certificate.noRetake': 'Certificate: {{titles}} can no longer be retaken. Contact your trainer.',
  'home.certificate.notPassed': 'Certificate: pass {{titles}} to earn it.',
  'home.certificate.scoreTooLow': 'Certificate: score at least {{score}}% on {{titles}} to earn it.',
  'home.certificate.download': 'Certificate',
  'survey.title': 'Your opinion on this training',
  'survey.intro': 'A few questions before your certificate. Everything is optional, and your answers are read without your name.',
  'survey.modules.title': 'Was each module useful to you?',
  'survey.scale.low': 'Not at all',
  'survey.scale.high': 'Completely',
  'survey.scale.option': '{{rating}} out of 5',
  'survey.skip': 'Skip',
  'survey.submit': 'Send',
  'surveyEditor.title': 'Survey',
  'surveyEditor.intro': 'Offered to each learner right before their certificate, never required: they can skip it. Answers are read without names, on each session\'s page. The overall satisfaction question makes the satisfaction rate; each module is also rated, apart. Answers already given keep the labels they read.',
  'surveyEditor.question': 'Question {{number}}',
  'surveyEditor.kind': 'Answer',
  'surveyEditor.kind.scale': 'Rating from 1 to 5',
  'surveyEditor.kind.text': 'Free text',
  'surveyEditor.overall': 'Overall satisfaction (base of the rate)',
  'surveyEditor.moveUp': 'Move {{name}} up',
  'surveyEditor.moveDown': 'Move {{name}} down',
  'surveyEditor.remove': 'Remove {{name}}',
  'surveyEditor.add': 'Add a question',
  'surveyEditor.saved': 'Survey saved',
  'surveyEditor.saveFailed': 'The survey could not be saved.',
  'surveyEditor.error.empty': 'Keep at least one question.',
  'surveyEditor.error.label': 'Every question needs a label.',
  'surveyEditor.error.overall': 'Choose a question rated 1 to 5 as the overall satisfaction.',
  'survey.results.title': 'Learner satisfaction',
  'survey.results.empty': 'No learner has been offered the survey yet: it comes with the certificate.',
  'survey.results.satisfaction': 'Satisfaction rate',
  'survey.results.satisfactionMethod': 'Ratings of 4 or 5 ÷ ratings given to overall satisfaction',
  'survey.results.responses': 'Responses',
  'survey.results.skipped_one': '{{count}} learner skipped the survey',
  'survey.results.skipped_other': '{{count}} learners skipped the survey',
  'survey.results.questions': 'Questions',
  'survey.results.modules': 'Module evaluation',
  'survey.results.comments': 'Comments',
  'survey.results.average': '{{average}} / 5 ({{count}})',
  'home.certificate.error': 'Your certificate could not be downloaded. Please try again in a moment.',
  'home.summary_one': '{{count}} training finished out of {{total}}',
  'home.summary_other': '{{count}} trainings finished out of {{total}}',
  // Caption under "1 / 3" in the banner: the total already shows beside it.
  'home.summaryCaption_one': 'training finished',
  'home.summaryCaption_other': 'trainings finished',
  // Banner button: it leads to the training the situational line names.
  'home.hero.resume': 'Resume',
  'home.hero.start': 'Start',
  'home.empty.hint': 'As soon as a trainer enrolls you in a training, it will show up here.',

  // Certificates (back-office)
  'common.certificates': 'Certificates',
  'certificates.template.title': 'Certificate template',
  'certificates.field.title': 'Title',
  'certificates.field.body': 'Text',
  'certificates.field.signature': 'Signature',
  'certificates.field.signaturePlaceholder': 'Signatory name (optional)',
  'certificates.field.showScore': 'Show score',
  'certificates.field.showDate': 'Show date',
  'certificates.field.showTotalTime': 'Show time spent',
  'certificates.email.title': 'Notify the learner',
  'certificates.field.emailOnUnlock': 'Send an email when the certificate is available',
  'certificates.email.help': 'For the paths using this template, the learner receives an email with a link to their path when their certificate becomes available: everything finished, certificate condition met. One email per path; certificates earned before you turn it on do not trigger one.',
  'certificates.field.orientation': 'Orientation',
  'certificates.orientation.landscape': 'Landscape',
  'certificates.orientation.portrait': 'Portrait',
  'certificates.field.logo': 'Certificate logo',
  'certificates.logo.help': 'PNG or JPEG, 512 KB max. Otherwise the platform logo is used.',
  'certificates.logo.fallback': 'No dedicated logo — the platform logo will be used.',
  'certificates.logo.upload': 'Upload',
  'certificates.logo.remove': 'Remove',
  'certificates.logo.typeError': 'Unsupported format: PNG or JPEG only.',
  'certificates.logo.sizeError': 'File too large (512 KB max).',
  'certificates.logo.readError': 'Could not read the file.',
  'certificates.field.skeleton': 'PDF skeleton (letterhead)',
  'certificates.skeleton.help': 'Single-page PDF, 3 MB max, unprotected. Used as background; the decorative frame is then not drawn.',
  'certificates.skeleton.active': 'Skeleton uploaded',
  'certificates.skeleton.none': 'No skeleton',
  'certificates.skeleton.upload': 'Upload a PDF',
  'certificates.skeleton.replace': 'Replace',
  'certificates.skeleton.remove': 'Remove',
  'certificates.skeleton.typeError': 'The skeleton must be a PDF file.',
  'certificates.skeleton.sizeError': 'PDF too large (3 MB max).',
  'certificates.skeleton.readError': 'Could not read the PDF.',
  'certificates.field.margins': 'Text margins (points)',
  'certificates.margins.help': 'Text block position, mainly useful with a skeleton. 0 to 300.',
  'certificates.margins.marginTop': 'Top',
  'certificates.margins.marginBottom': 'Bottom',
  'certificates.margins.marginLeft': 'Left',
  'certificates.margins.marginRight': 'Right',
  'certificates.placeholders.help': 'Available variables:',
  'certificates.preview': 'Preview',
  'certificates.previewError': 'Unable to generate the preview.',
  'certificates.saved': 'Template saved.',
  'certificates.saveError': 'Saving failed.',
  'trainerCapabilities.intro': 'Choose what the Trainer role can do in your organization. These settings apply to every trainer; administrators keep all their permissions. Good to know: a visible path shows its enrolled learners, and the CSV export is hidden without the export permission, but it reuses the tracking table the trainer already sees.',
  'trainerCapabilities.domain.sessions': 'Paths',
  'trainerCapabilities.domain.modules': 'Modules',
  'trainerCapabilities.domain.learners': 'Learners',
  'trainerCapabilities.domain.statistics': 'Statistics',
  'trainerCapabilities.cap.SESSIONS_VIEW': 'View paths',
  'trainerCapabilities.cap.SESSIONS_MANAGE': 'Create and edit paths',
  'trainerCapabilities.cap.SESSIONS_DELETE': 'Delete paths',
  'trainerCapabilities.cap.MODULES_VIEW': 'View and preview modules',
  'trainerCapabilities.cap.MODULES_IMPORT': 'Import modules',
  'trainerCapabilities.cap.MODULES_DELETE': 'Delete modules',
  'trainerCapabilities.cap.LEARNERS_VIEW': 'Open the Learners screen (and groups)',
  'trainerCapabilities.cap.STATISTICS_VIEW': 'View tracking and statistics',
  'trainerCapabilities.cap.STATISTICS_EXPORT': 'Export statistics (PDF, CSV)',
  'trainerCapabilities.requires': 'Requires: {{list}}',
  'trainerCapabilities.loadError': 'Could not load trainer permissions. Reload the page before changing them.',
  'trainerCapabilities.saved': 'Trainer permissions saved.',
  'trainerCapabilities.saveError': 'Saving failed.',
  'common.reminders': 'Email reminders',
  'reminders.cadence.title': 'Reminder cadence',
  'reminders.message.title': 'Message sent',
  'reminders.field.enabled': 'Enable reminders',
  'reminders.enabled.help': 'Enrolled learners who have not completed their training receive an automatic reminder.',
  'reminders.digest.title': 'Completed paths digest',
  'reminders.field.completionDigestEnabled': 'Send the digest to administrators every morning',
  'reminders.convocation.title': 'Enrollment convocation',
  'reminders.field.convocationEnabled': 'Send a convocation to every enrolled learner',
  'reminders.convocation.help': 'The learner receives the path name, its dates, estimated duration and access link. Accounts without an email address get none. The sending date is exported in reports.',
  'reminders.digest.help': 'Every day around 7 a.m. (your organization\'s time), all administrators receive the list of paths completed since the previous digest. Nothing is sent when there is nothing new.',
  'reminders.field.firstDelayDays': 'Delay before the first reminder (days)',
  'reminders.field.frequencyDays': 'Interval between two reminders (days)',
  'reminders.frequencyDays.help': 'At least 3 days: below that, a reminder reads as spam.',
  'reminders.field.maxReminders': 'Maximum number of reminders',
  'reminders.maxReminders.help': 'Between 1 and 10 reminders per enrolment. The “no limit” option is gone: chasing learners indefinitely gets your messages flagged as spam, invitations and certificates included.',
  'reminders.field.sendHour': 'Sending hour (0-23)',
  'reminders.field.subject': 'Subject',
  'reminders.field.body': 'Message body',
  'reminders.placeholders.help': 'Available variables:',
  'reminders.sendTest': 'Send me a test',
  'reminders.testSent': 'Test reminder sent to {{email}}.',
  'reminders.testError': 'Test sending failed. Check the SMTP configuration.',
  'reminders.saved': 'Reminders saved.',
  'reminders.saveError': 'Saving failed.',

  // SSO (#40)
  'common.trainerCapabilities': 'Trainer permissions',
  'common.webhooks': 'Webhooks',
  'common.sso': 'SSO authentication',
  'sso.picker.title': 'Provider to configure',
  'sso.picker.help': 'Pick a provider to show its fields. You can configure and enable several: the ones not on screen stay in place.',
  'sso.picker.configured': 'Already configured:',
  'sso.picker.none': 'No provider configured yet.',
  'sso.picker.status.enabled': 'enabled',
  'sso.picker.status.draft': 'draft',
  'webhooks.intro': 'Studeva notifies your system (HR system, training ERP…) when a learner completes a module or a path: a signed HTTPS call, retried until it is received.',
  'webhooks.endpoint.title': 'Destination',
  'webhooks.endpoint.url': 'URL receiving the calls',
  'webhooks.endpoint.urlHelp': 'HTTPS required, on a host reachable from the Internet.',
  'webhooks.endpoint.enabled': 'Send calls',
  'webhooks.saved': 'Destination saved.',
  'webhooks.saveError': 'The operation failed.',
  'webhooks.secret.copyFailed': 'Copy failed: select the secret and copy it by hand.',
  'webhooks.secret.regenerateTitle': 'Replace the secret?',
  'webhooks.secret.regenerateWarning': 'The old secret will stop signing at once: your system will refuse our calls until it has the new one.',
  'webhooks.deliveries.nextAttempt': 'Next attempt: {{date}}',
  'webhooks.error.TIMEOUT': 'Timed out',
  'webhooks.error.BLOCKED_ADDRESS': 'Internal address refused',
  'webhooks.error.DNS': 'Name not found',
  'webhooks.error.TLS': 'Certificate refused',
  'webhooks.error.CONNECTION': 'Connection refused',
  'webhooks.error.DESTINATION_OFF': 'Destination turned off',
  'webhooks.error.INVALID_URL': 'URL refused',
  'webhooks.error.UNKNOWN': 'Unknown error',
  'webhooks.secret.title': 'Signing secret',
  'webhooks.secret.once': 'Copy this secret now: it will never be shown again.',
  'webhooks.secret.copy': 'Copy the secret',
  'webhooks.secret.copied': 'Secret copied.',
  'webhooks.secret.hidden': 'The secret is stored and no longer shown. Replace it if you lost it.',
  'webhooks.secret.none': 'A secret is generated when the destination is saved.',
  'webhooks.secret.verify': 'Each call carries the X-Studeva-Signature header: t=<timestamp>,v1=<HMAC-SHA256 of "timestamp.body" with this secret>. Recompute it to check the call comes from Studeva.',
  'webhooks.secret.regenerate': 'Replace the secret',
  'webhooks.test': 'Send a test',
  'webhooks.testQueued': 'Test call queued: it goes out as soon as possible.',
  'webhooks.deliveries.title': 'Latest deliveries',
  'webhooks.deliveries.empty': 'No delivery yet.',
  'webhooks.deliveries.date': 'Date',
  'webhooks.deliveries.event': 'Event',
  'webhooks.deliveries.attempts': 'Attempts',
  'webhooks.deliveries.response': 'Last response',
  'webhooks.status.PENDING': 'Queued',
  'webhooks.status.SENDING': 'Sending',
  'webhooks.status.DELIVERED': 'Received',
  'webhooks.status.FAILED': 'Given up',
  'sso.intro': 'Enable one or more identity providers for your organization. Until one is enabled, the login screen shows no SSO button.',
  'sso.master.title': 'SSO sign-in',
  'sso.master.help': 'Master switch, above individual providers. Off until you turn it on; turning it off again removes every SSO button from the login screen without erasing the configurations below.',
  'sso.master.off': 'SSO is off: no button appears on the login screen, even for the providers enabled below.',
  'sso.master.turnedOn': 'SSO sign-in enabled.',
  'sso.master.turnedOff': 'SSO sign-in turned off.',
  'sso.field.enabled': 'Enabled',
  'sso.field.label': 'Button label',
  'sso.label.help': 'Text shown on the login screen.',
  'sso.field.issuer': 'Issuer',
  'sso.field.clientId': 'Client ID',
  'sso.field.clientSecret': 'Client secret',
  'sso.clientSecret.help': 'Encrypted before storage. It will never be displayed again.',
  'sso.clientSecret.stored': 'Secret stored. Leave empty to keep it.',
  'sso.field.entryPoint': 'IdP sign-on URL',
  'sso.field.idpIssuer': 'IdP entity ID',
  'sso.field.idpCert': 'Signing certificate (PEM)',
  'sso.field.allowedDomains': 'Allowed email domains',
  'sso.allowedDomains.help': 'Empty = any domain returned by the provider is accepted. An account is created automatically on first login.',
  'sso.allowedDomains.required': 'This provider also authenticates accounts outside your organization — any Gmail address in Google\'s case. Enter at least one domain before enabling it.',
  'sso.idpSetup.title': 'Declare on the provider side:',
  'sso.saved': 'Provider saved.',
  'sso.saveError': 'Saving failed.',
  'sso.deleted': 'Provider deleted.',
  'sso.deleteError': 'Deletion failed.',
  'sso.delete.title': 'Delete {{provider}}',
  'sso.delete.first-message': 'The configuration and client secret will be lost: restoring it means issuing a new one from the provider. If this provider is enabled, learners who sign in through it will no longer be able to log in.',
  'sso.callback.checking': 'Signing you in',
  'sso.callback.checking.description': 'We are validating your identity with your provider.',
  'sso.callback.failed.title': 'Sign-in failed',
  'sso.callback.failed.description': 'The sign-in link expired or was already used. Start again from the login screen.',
  'sso.error.demoLearnerLimit': 'Your organization has reached the maximum number of learners of its demo space. Contact its administrator.',
  'sso.error.generic': 'SSO sign-in failed. Try again or contact your administrator.',
  'sso.error.domainNotAllowed': 'Your email domain is not allowed for this organization.',
  'sso.error.accountDisabled': 'Your account is disabled. Contact your administrator.',
  'sso.error.emailAlreadyUsed': 'This address already belongs to another organization.',
  'sso.error.providerUnavailable': 'This identity provider is unavailable.',

  // SCORM player. These screens are the learner's: they say what is happening
  // and what can be done about it, not what failed server-side. "SCORM" and
  // "session" are tooling vocabulary and have no place here.
  'scorm.player.backToSessions': 'My trainings',
  'scorm.player.unavailable': 'This module is not available right now.',
  'scorm.player.retakeNotAllowed': 'You have completed this module, and it cannot be retaken.',
  'scorm.player.contentError': 'This module could not be opened. Let your trainer know and they will put it back online.',

  // Player end screen (the module called Terminate)
  'scorm.finished.completedTitle': 'Congratulations, you have completed this module!',
  'scorm.finished.pathCompletedTitle': 'Congratulations, you have completed the whole training!',
  'scorm.finished.pathCompletedHint': 'Your certificate is waiting for you on the home page.',
  'scorm.finished.title': 'End of module',

  // Impersonation in the player
  'scorm.impersonate.noTracking': 'View mode: progress is not recorded',

  // Module preview (Admin/Trainer)
  'scorm.preview.badge': 'Preview',
  'scorm.preview.noTracking': 'No progress is recorded.',
  'scorm.preview.backToModules': 'Back to modules',
  'scorm.preview.unavailable': 'This module is not ready to be played.',

  // Statistics export
  'stats.export.email': 'Email',
  'stats.export.session': 'Session',
  'stats.export.completion': 'Completion',
  'stats.export.success': 'Success',
  'stats.export.score': 'Score',
  'stats.export.totalTime': 'Total time',
  'stats.export.completedAt': 'Completed at',

  // Statistics dashboard
  'stats.dashboard.progressTitle': 'Progress',
  'stats.dashboard.scopeTitle': 'Overall progress',
  'stats.report.download': 'PDF report',
  'stats.report.failed': 'The report could not be generated.',
  'stats.trend.title': 'Modules completed over the period',
  'stats.trend.range': 'Chart depth',
  'stats.trend.days_one': '{{count}} day',
  'stats.trend.days_other': '{{count}} days',
  'stats.trend.empty': 'No module completed over this period.',
  'stats.trend.tooltip_one': '{{count}} module completed on {{day}}',
  'stats.trend.tooltip_other': '{{count}} modules completed on {{day}}',
  'stats.trend.alt': 'Completed modules chart: {{count}} in total over the last {{days}} days.',
  'stats.dashboard.scope': 'Learners enrolled in a session',
  'stats.dashboard.breakdownBasis': 'Breakdown counted module by module ({{modules}} in all): a learner enrolled in a three-module path counts three times.',
  'stats.dashboard.noModules': 'Their sessions do not contain any module yet: nothing to measure for now.',
  'stats.dashboard.noEnrollments': 'No learner enrolled in this scope.',
  'stats.dashboard.notYetUnlocked': 'Not open yet',
  'stats.dashboard.notYetUnlocked.hint': '{{modules}} modules are not unlocked yet for their learners: they count toward the total without counting as falling behind.',
  'stats.dashboard.neverOpened': '{{learners}} enrolled learners have never opened their module: they count towards the total, but do not appear in the table below.',
  'stats.dashboard.averageScore': 'Average score',
  'stats.dashboard.scoredOn': 'over {{scored}} scored paths out of {{total}}',
  'stats.dashboard.noScore': 'No score recorded in this scope',
  'stats.dashboard.successRate': 'Success rate',
  'stats.dashboard.successOn': '{{passed}} passed out of {{evaluated}} assessed',
  'stats.dashboard.noSuccess': 'No success verdict in this scope',
  'stats.dashboard.averageTime': 'Average time spent',
  'stats.dashboard.totalTime': 'Total training time',
  'stats.dashboard.timedOn': 'over {{timed}} timed paths out of {{total}}',
  'stats.dashboard.noTime': 'No duration recorded in this scope',

  // Back-office home (#201). Sentences, not metric labels: every line on this
  // screen should read out loud. The tone is a colleague catching you up in the
  // morning — warm, never bookkeeping: "still a few people to support", not
  // "4 non-conformities".
  'common.routing.home': 'Home',
  'backHome.greeting': 'Hello {{name}}',
  'backHome.subtitle.attention_one': 'One thing is waiting for you today.',
  'backHome.subtitle.attention_other': '{{count}} things are waiting for you today.',
  'backHome.subtitle.clear': 'All caught up — nothing is waiting for you today.',
  'backHome.section.attention': 'Worth a closer look',
  'backHome.section.upcoming': 'Coming up',
  'backHome.section.today': 'Good news today',
  'backHome.overdue.title_one': '{{name}}: {{count}} learner has not finished yet',
  'backHome.overdue.title_other': '{{name}}: {{count}} learners have not finished yet',
  'backHome.overdue.detail': 'The deadline was {{date}}. Now is a good time for a nudge.',
  'backHome.overdue.more_one': 'And {{count}} other path in the same situation.',
  'backHome.overdue.more_other': 'And {{count}} other paths in the same situation.',
  'backHome.overdue.learners_one': 'In total, {{count}} learner is affected.',
  'backHome.overdue.learners_other': 'In total, {{count}} learners are affected, some across several paths.',
  'backHome.endingSoon.title': '{{name}} ends on {{date}}',
  'backHome.endingSoon.detail_one': '{{count}} learner out of {{total}} still needs a hand.',
  'backHome.endingSoon.detail_other': '{{count}} learners out of {{total}} still need a hand.',
  'backHome.startingSoon.title': '{{name}} starts on {{date}}',
  'backHome.startingSoon.detail_one': '{{count}} learner is expected.',
  'backHome.startingSoon.detail_other': '{{count}} learners are expected.',
  'backHome.completedToday.title_one': '{{count}} learner wrapped up "{{module}}"',
  'backHome.completedToday.title_other': '{{count}} learners wrapped up "{{module}}"',
  'backHome.neverStarted.title_one': '{{count}} learner has not taken the first step yet',
  'backHome.neverStarted.title_other': '{{count}} learners have not taken the first step yet',
  'backHome.neverStarted.detail_one': 'Enrolled in a path that has already started, without opening a single module.',
  'backHome.neverStarted.detail_other': 'Enrolled in a path that has already started, without opening a single module.',
  'backHome.empty': 'Nothing to report: no deadline in sight, nobody to chase. Enjoy it.',
  'backHome.empty.cta': 'Take a look at the paths',

  'notice.stats.title': 'Your data and your training record',
  'notice.stats.intro': '{{appName}} records your progress in order to produce the learning record for your course. This notice is provided for transparency: it requires nothing from you.',
  'notice.stats.purpose': 'Purpose: measure your progress, attendance and results, and produce the certificates and records your training provider must be able to supply.',
  'notice.stats.data': 'Data involved: your identity (first name, last name, email address) linked to your progress on the modules, and a log of your logins (date and sign-in method), kept for 12 months.',
  'notice.stats.legalBasis': 'Legal basis: performance of your training contract (GDPR article 6.1.b) and the record-keeping obligations placed on your training provider (article 6.1.c).',
  'notice.stats.rights': 'Your rights: access, rectification, restriction and objection are exercised with your training provider. This notice remains available at any time via the “My data” link.',
  'notice.stats.noConsentNeeded': 'This processing is not based on your consent: there is nothing to accept or decline, and your access to your courses does not depend on it.',
  'notice.stats.manage': 'My data',

  // Qualified self-service trial signup (#155)
  'findOrganization.title': 'Sign in',
  'findOrganization.subtitle': 'Each training organization has its own space on Studeva. Tell us yours to reach its sign-in screen.',
  'findOrganization.field': 'Your organization\'s identifier',
  'findOrganization.placeholder': 'my-organization',
  'findOrganization.hint': 'It appears in your space\'s address, after “/o/”. You can also paste that address. Your organization shared it with your invitation.',
  'findOrganization.submit': 'Continue',
  'findOrganization.error.unknown': 'No organization has this identifier. Check it in your organization\'s invitation email, or ask its administrator.',
  'findOrganization.error.generic': 'The search didn\'t go through. Try again in a moment.',
  'signup.title': 'Create your trial space',
  'signup.choice.subtitle': 'Who are you? We\'ll tailor the next step to your profile.',
  'signup.choice.org.title': 'I\'m a training organization',
  'signup.choice.org.description': 'Create your free trial space and invite your learners.',
  'signup.choice.learner.title': 'I\'m a learner or a trainer',
  'signup.choice.learner.description': 'You\'re joining an existing organization.',
  'signup.learner.description': 'Learner and trainer accounts are created by your training organization. Reach out to its administrator: they\'ll send you an email invitation. There\'s no self-service sign-up for these profiles.',
  'signup.back': 'Back',
  'signup.form.subtitle': 'A few details to open your space. No credit card required.',
  'signup.form.email': 'Work email',
  'signup.form.email.hint': 'Use your organization\'s address — public providers (gmail, outlook…) aren\'t accepted.',
  'signup.form.orgName': 'Organization name',
  'signup.form.jobTitle': 'Job title (optional)',
  'signup.form.phone': 'Phone (optional)',
  'signup.form.submit': 'Create my trial space',
  'signup.form.terms': 'I accept the <cgv>terms of sale</cgv> and the <cgu>terms of use</cgu>.',
  'signup.form.terms.required': 'Accept the terms to create your space.',
  'legal.acceptance.title': 'Platform terms',
  'legal.acceptance.intro': 'To continue, read the following documents and accept them. They open in a new tab.',
  'legal.acceptance.version': 'version of {{version}}',
  'legal.links.newTab': '(opens in a new tab)',
  'legal.acceptance.accept': 'I accept',
  'legal.acceptance.error': 'Your acceptance could not be saved. Try again.',
  'legal.document.TERMS_OF_USE': 'Terms of use',
  'legal.document.TERMS_OF_SALE': 'Terms of sale',
  'legal.document.PRIVACY': 'Privacy policy',
  'legal.links.label': 'Legal information',
  'signup.sent.title': 'Check your inbox',
  'signup.sent.description': 'If a valid work email was provided, a confirmation email was just sent to {{email}}. Click the link inside to confirm your address — your request will then be reviewed by our team.',
  'signup.error.publicEmail': 'Please use a work email address.',
  'signup.error.generic': 'Something went wrong. Please try again in a moment.',

  'confirmTrial.title': 'Confirming your email',
  'confirmTrial.loading': 'Recording your confirmation…',
  'confirmTrial.pending': 'Thanks! Your address is confirmed. Your request is now being reviewed by our team — you\'ll get an email as soon as it\'s approved.',
  'confirmTrial.approved': 'Your space has been approved! Check the activation email we just sent to set your password.',
  'confirmTrial.goToLogin': 'Go to login',
  'confirmTrial.rejected': 'Your request was not approved.',
  'confirmTrial.reason': 'Reason:',
  'confirmTrial.expired': 'This confirmation link has expired. Start a new trial request to get a fresh one.',
  'confirmTrial.error': 'This confirmation link is invalid.',
  'confirmTrial.restart': 'Start a new request',

  // Platform review of trial requests (#155, SuperAdmin)
  'trialRequests.title': 'Trial requests',
  'trialRequests.intro': 'Organizations that confirmed their address and are waiting for their space to be created.',
  'trialRequests.empty': 'No pending requests.',
  'trialRequests.col.org': 'Organization',
  'trialRequests.col.requester': 'Requester',
  'trialRequests.col.jobTitle': 'Job title',
  'trialRequests.col.confirmedAt': 'Confirmed on',
  'trialRequests.col.actions': 'Actions',
  'trialRequests.approve': 'Approve',
  'trialRequests.reject': 'Reject',
  'trialRequests.approved': 'Space created for {{org}} — activation sent.',
  'trialRequests.rejected': 'Request from {{org}} rejected.',
  'trialRequests.error': 'Something went wrong.',
  'trialRequests.rejectTitle': 'Reject the request from {{org}}?',
  'trialRequests.reasonLabel': 'Rejection reason (optional)',
  'trialRequests.reasonPlaceholder': 'e.g. organization could not be identified…',
  'trialRequests.reasonHelp': 'The reason is included in the email sent to the requester.',
  'trialRequests.confirmReject': 'Reject and notify',

  // Per-plan capability gating (#155)

  // Organization slug rename (#155)
  'organization.rename.title': 'Rename organization?',
  'organization.rename.warning': 'You\'re changing the slug from “{{from}}” to “{{to}}”. This takes effect immediately and breaks everything pointing to the old address.',
  'organization.rename.break.urls': 'Links and bookmarks to the old address stop working.',
  'organization.rename.break.login': 'The login screen and branding resolved by the old slug no longer respond.',
  'organization.rename.break.emails': 'Emails already sent (login, activation, reminders) point to the old address.',
  'organization.rename.confirm': 'Rename anyway',
  'pageTitle.findOrganization': 'Sign in',
  'pageTitle.login': 'Sign in',
  'pageTitle.logout': 'Sign out',
  'pageTitle.resetPassword': 'Forgot password',
  'pageTitle.newPassword': 'New password',
  'pageTitle.validAccount': 'Account validation',
  'pageTitle.createAccount': 'Account creation',
  'pageTitle.magicLink': 'Sign-in link',
  'pageTitle.sso': 'SSO sign-in',
  'pageTitle.denied': 'Access denied',
  'pageTitle.signup': 'Create your workspace',
  'pageTitle.confirmTrial': 'Trial confirmation',
  'pageTitle.demoPath': 'Demo: path',
  'pageTitle.demoPlayer': 'Demo: player',
  'pageTitle.demoSession': 'Demo: session page',
  'pageTitle.demoPreview': 'Demo: preview',
  'pageTitle.path': 'Path',
  'pageTitle.player': 'Module player',
  'pageTitle.preview': 'Module preview',
  'pageTitle.error': 'Error',
  'pageTitle.notFound': 'Page not found',
  'pageTitle.announce': 'Page: {{title}}',
  'a11y.skipToContent': 'Skip to content',
  'a11y.backOfficeNav': 'Back-office navigation',
  'path.step.status.done': 'Completed',
  'path.step.status.available': 'Available',
  'path.step.status.locked': 'Locked',
  'score.passed': 'pass mark reached',
  'score.notPassed': 'pass mark not reached',
  'common.actionFor': '{{action}}: {{name}}',
  'users.you': '(you)',
  'users.empty': 'No users.',
  'form.requiredHint': 'Fields marked with an asterisk (*) are required.',
  'users.import.previewTable': 'Import preview',
  'billing.learnerCounters.table': 'Learners per organization',
  'path.progress.label': 'Path progress',
  'storage.usage.progress': 'Storage space used',
  'login.language.toggle': '{{current}} — switch to {{target}}',
  'learner.logoLink': '{{appName}} — My trainings',
  'sessions.path.dnd.instructions': 'To move a module, press Space or Enter to pick it up, use the up and down arrows, then Space or Enter to drop it, or Escape to cancel.',
  'sessions.path.dnd.start': 'Picked up “{{title}}”, position {{position}} of {{total}}.',
  'sessions.path.dnd.over': '“{{title}}” at position {{position}} of {{total}}.',
  'sessions.path.dnd.end': 'Dropped “{{title}}” at position {{position}} of {{total}}.',
  'sessions.path.dnd.cancel': 'Moving “{{title}}” cancelled.',
  'scorm.player.titleNamed': 'Module: {{name}}',
  'common.resultsCount_one': '{{count}} result',
  'common.resultsCount_other': '{{count}} results',
  'tours.certificates.templates.title': 'The templates',
  'tours.certificates.templates.body': 'Pick the template to edit. “New template” creates one to name, “Duplicate” copies the saved version of the one shown, “Set as default” makes it the template of the paths that choose none. “Delete” asks for confirmation and does not exist for the default template; the paths of a deleted template fall back on the default one. With unsaved changes, switching, creating or duplicating a template first asks you to discard them.',
  'certificates.field.name': 'Template name',
  'certificates.field.nameHelp': 'To find your way around; it is not printed — the title is.',
  'certificates.templates.title': 'Certificate templates',
  'certificates.templates.current': 'Template shown',
  'certificates.templates.defaultOption': '{{name}} (default)',
  'certificates.templates.new': 'New template',
  'certificates.templates.duplicate': 'Duplicate',
  'certificates.templates.makeDefault': 'Set as default',
  'certificates.templates.defaultHelp': 'This is the template of the paths that choose none: it cannot be deleted.',
  'certificates.templates.newName': 'New template name',
  'certificates.templates.create': 'Create',
  'certificates.templates.deleteTitle': 'Delete the “{{name}}” template?',
  'certificates.templates.deleteBody': 'The paths using it will fall back on the default template, including for certificates already earned.',
  'certificates.templates.error': 'The template operation failed.',
  'certificates.templates.created': 'Template created.',
  'certificates.templates.duplicated': 'Template duplicated.',
  'certificates.templates.defaultSet': 'Default template changed.',
  'certificates.templates.deleted': 'Template deleted.',
  'sessions.certificateTemplate.label': 'Certificate template',
  'sessions.certificateTemplate.default': 'Organization\'s default template',
  'sessions.certificateTemplate.defaultNamed': 'Organization\'s default template ({{name}})',
  'sessions.certificateTemplate.hint': 'Also applies to certificates already earned on this path: they are generated on each download.',
  'certificates.templates.copyName': '{{name}} (copy)',
  'certificates.templates.loadError': 'The certificate templates could not be loaded. Reload the page.',
  'certificates.templates.discardTitle': 'Discard your changes?',
  'certificates.templates.discard': 'Discard',
  'certificates.templates.discardBody': 'The template shown has unsaved changes: they will be lost.',
  'common.routing.questions': 'Question analysis',
  'questions.title': 'Question analysis',
  'questions.intro': 'The answers modules record, question by question. Pick a module; for each learner, their most recent answer counts. A question is recognized by the id the module gives it.',
  'questions.module': 'Module',
  'questions.chooseModule': 'Choose a module…',
  'questions.from': 'From',
  'questions.to': 'To',
  'questions.pickModule': 'Pick a module to see the answers to its questions.',
  'questions.empty': 'No answer recorded for this module in this scope. Some modules do not send their questions: it is a publishing setting.',
  'questions.loadError': 'The analysis could not be loaded.',
  'questions.tableLabel': 'Answers per question',
  'questions.column.question': 'Question',
  'questions.column.expected': 'Expected answer',
  'questions.column.respondents': 'Respondents',
  'questions.column.correctRate': 'Correct answers',
  'questions.column.averageScore': 'Average score',
  'questions.column.brackets': 'Score breakdown',
  'questions.bracket': '{{range}} %: {{count}}',
  'questions.export.questions': 'CSV per question',
  'questions.export.answers': 'CSV of answers',
  'questions.export.pdf': 'PDF report',
  'questions.export.pdfFailed': 'The report could not be generated.',
  'questions.export.questionsFile': 'question-analysis',
  'questions.export.answersFile': 'question-answers',
  'questions.csv.path': 'Path',
  'questions.csv.module': 'Learning unit',
  'questions.csv.respondents': 'Number of people',
  'questions.csv.question': 'Question',
  'questions.csv.questionId': 'Question id',
  'questions.csv.expected': 'Expected answer',
  'questions.csv.averageScore': 'Average score',
  'questions.csv.learnerResponse': '{{name}} — answer',
  'questions.csv.learnerScore': '{{name}} — score',
  'questions.csv.learner': 'Learner',
  'questions.csv.email': 'Email',
  'questions.csv.response': 'Answer',
  'questions.csv.result': 'Result',
  'questions.csv.score': 'Score',
  'questions.csv.attempt': 'Attempt',
  'tours.sessionDetail.title': 'Session page',
  'tours.sessionDetail.description': 'Look up a session: its settings, its path, its participants and their results.',
  'tours.sessionDetail.header.title': 'The session',
  'tours.sessionDetail.header.body': 'Its name, its status (“Active” or “Archived”), its start and end dates, and its tags. The page opens by clicking a session\'s name in the sessions list.',
  'tours.sessionDetail.edit.title': 'Edit',
  'tours.sessionDetail.edit.body': 'Opens the session form, the same as in the list: that is the one place where it changes. Confirm with “Save”. The button only shows to who may manage sessions.',
  'tours.sessionDetail.kpis.title': 'Indicators',
  'tours.sessionDetail.kpis.body': 'The dashboard figures, restricted to this session: participants, progress module by module, success rate, average score, average time, total training time and dropout rate. This block, the participants table and the exports require access to statistics.',
  'tours.sessionDetail.survey.title': 'Satisfaction',
  'tours.sessionDetail.survey.body': 'What learners said about the path, without any name: the survey is offered to them, never required, just before their certificate. The satisfaction rate counts the 4 and 5 ratings on the overall satisfaction question; then come the average of each question, the rating of each module (the content evaluation) and the comments.',
  'tours.sessionDetail.info.title': 'Information',
  'tours.sessionDetail.info.body': 'Creation date, progression mode (free or sequential) and what the certificate requires, with the certificate template used.',
  'tours.sessionDetail.trainers.title': 'Trainers',
  'tours.sessionDetail.trainers.body': 'Who runs the session: each one\'s name, role (trainer or administrator) and email address — a trainer doesn\'t see an administrator\'s. They are chosen in the session form ("Edit", then "Save"). The assignment is informative: it doesn\'t change anyone\'s rights.',
  'tours.sessionDetail.path.title': 'The path',
  'tours.sessionDetail.path.body': 'The modules in order, chapter by chapter, with their locks: the module to complete first (and the minimum score required) or the opening date. On the right, how many participants completed each module.',
  'tours.sessionDetail.participants.title': 'The participants',
  'tours.sessionDetail.participants.body': 'One row per enrolled learner: name and email address, groups, progress, completed modules, average score, time spent and last activity. Below the table: “Previous” and “Next” to change pages, and the number of rows per page.',
  'tours.sessionDetail.filter.title': 'Filter by progress',
  'tours.sessionDetail.filter.body': 'Keep only the participants who never started, are in progress, completed or dropped out.',
  'tours.sessionDetail.exports.title': 'Exports',
  'tours.sessionDetail.exports.body': '“Results (CSV)” downloads the participants shown, filter included; “PDF report”, the session activity report. Both buttons require the right to export statistics. “Question analysis” opens the analysis filtered on this session.',
  'tours.sessionDetail.attendance.title': 'Attendance statements',
  'tours.sessionDetail.attendance.body': 'A PDF with the statement of every enrolled learner, one page each: measured time per module, attempts, dates, scores, sign-in days, measurement method and the organization\'s attestation. It proves the distance training was followed (Qualiopi, indicator 19). For administrators.',
  'tours.sessionDetail.dropout.title': 'Declare a dropout',
  'tours.sessionDetail.dropout.body': 'On the row of a learner who left: “Declare a dropout”, pick the reason, add details if needed, then “Declare the dropout”. They no longer get reminders and leave the late alerts; their results stay. “Cancel the dropout” brings them back. The dropout rate shows in the indicators, with its calculation method. For those who can manage sessions.',
  'tours.questions.title': 'Question analysis',
  'tours.questions.description': 'See how learners answer each question of a module, and export it.',
  'tours.questions.filters.title': 'Module and filters',
  'tours.questions.filters.body': 'First pick the module to analyse: nothing shows before. A path narrows the list to its modules; the group and the period (from… to…, answer dates) narrow the learners counted. Everything applies at once.',
  'tours.questions.table.title': 'The questions',
  'tours.questions.table.body': 'Once the module is picked, one row per question, in the module order: the expected answer, the number of respondents, the share of correct answers, the average score and the score breakdown. For a learner, only their most recent answer counts. Below the table: “Previous” and “Next” to change pages, and the number of rows per page.',
  'tours.questions.exports.title': 'Export',
  'tours.questions.exports.body': 'Active as soon as there are answers. “CSV per question” puts one row per question, with its summary then each learner\'s answer and score; “CSV of answers” puts one answer per row; “PDF report” downloads the same analysis as a PDF. All three follow the screen\'s filters.',
  'questions.learners_one': '{{count}} learner answered',
  'questions.learners_other': '{{count}} learners answered',
  'questions.learner.title': 'Learner\'s answers',
  'questions.learner.attempt': 'Attempt {{number}} — {{path}}',
  'questions.learner.answer': 'Their answer',
  'questions.learner.result': 'Result',
  'questions.learner.noAnswer': 'No answer recorded during this attempt.',
  'questions.learner.empty': 'No attempt on this module.',
  'questions.learner.loadError': 'The answers could not be loaded.',
  'tours.questions.learners.title': 'A learner\'s answers',
  'tours.questions.learners.body': 'The learners who answered, to find with the search. Each one opens a panel with their attempts on the module — path, status, score, date — and, for each one, their answers question by question. Below the list: “Previous” and “Next” to change pages, and the number of rows per page.',
  'questions.periodReversed': 'The start date is after the end date.',
  'questions.export.failed': 'The export could not be generated.',
  'tours.dashboard.table.title': 'Progress per learner',
  'tours.dashboard.table.body': 'One row per learner and path module, to search, filter by path or group, refresh (arrows) and export as CSV. A corrected score carries the “corrected” mention, and the export flags it. Admins correct it with the pencil in the Score column: a score in %, a required reason, then “Save the correction”; the panel keeps the history and lets you revoke the correction in force.',
  'scoreCorrection.title': 'Correct the score',
  'scoreCorrection.open': 'Correct {{name}}\'s score',
  'scoreCorrection.corrected': 'corrected',
  'scoreCorrection.current': 'Score in force',
  'scoreCorrection.inForce': 'This score is a correction: it overrides the attempts, even new ones, until it is revoked.',
  'scoreCorrection.revoke': 'Revoke the correction',
  'scoreCorrection.revokeTitle': 'Revoke the correction?',
  'scoreCorrection.revokeBody': 'The score goes back to the one computed from the learner\'s attempts. The correction stays in the history.',
  'scoreCorrection.new': 'New correction',
  'scoreCorrection.percent': 'Corrected score (%)',
  'scoreCorrection.reason': 'Reason',
  'scoreCorrection.reasonHelp': 'Kept in the history, with your name and the date.',
  'scoreCorrection.save': 'Save the correction',
  'scoreCorrection.history': 'History',
  'scoreCorrection.noHistory': 'No correction for this score.',
  'scoreCorrection.entry': '{{from}} → {{to}}',
  'scoreCorrection.by': 'By {{who}}, on {{when}}',
  'scoreCorrection.ended': 'Ended by {{who}}, on {{when}}',
  'scoreCorrection.deletedAccount': 'a deleted account',
  'scoreCorrection.saved': 'Correction saved.',
  'scoreCorrection.revoked': 'Correction revoked.',
  'scoreCorrection.error': 'The score operation failed.',
  'scoreCorrection.loadError': 'The history could not be loaded.',
  'scoreCorrection.csvColumn': 'Corrected score',
  'scoreCorrection.csvYes': 'yes',
  'scorm.chapters.label': 'Chapter',
  'scorm.chapters.option': '{{position}}. {{title}}',
  'scorm.chapters.optionDone': '{{position}}. {{title}} — done',
  'scorm.chapters.finishedTitle': 'Chapter completed',
  'scorm.chapters.next': 'Next chapter: {{title}}',
  'help.demo.chapters.intro': 'Introduction',
  'help.demo.chapters.basics': 'The basics',
  'help.demo.chapters.quiz': 'Final quiz',
  'tours.player.chapters.title': 'The chapters',
  'tours.player.chapters.body': 'When the module has several chapters, pick one in the list then “Open”, in any order; the ones you finished are marked “done”. You resume each one where you left it, and the module is complete once all its chapters are.',
  'scorm.chapters.open': 'Open',
  'scorm.chapters.switching': 'Opening the chapter…',
  'scorm.chapters.leftTitle': 'Chapter left unfinished',
  'tours.preview.chapters.title': 'The chapters',
  'tours.preview.chapters.body': 'When the package has several chapters (SCOs), pick one then “Open” to check each of them; nothing is saved here either.',
  // Fiche apprenant (#242)
  'profile.back': 'Back to users',
  'profile.notFound': 'This user could not be found.',
  'profile.email': 'Email',
  'profile.indicators.title': 'Indicators',
  'profile.indicators.trainingTime': 'Training time',
  'profile.indicators.trainingTimeHint': 'Time spent in modules',
  'profile.indicators.logins': 'Logins',
  'profile.indicators.loginsHint': 'Over the last 12 months',
  'profile.indicators.lastLogin': 'Last login',
  'profile.indicators.noLogin': 'No login recorded',
  'profile.indicators.lastLoginTime': 'at {{time}}',
  'profile.indicators.frequency': 'Frequency',
  'profile.indicators.frequencyValue': '{{days}} d',
  'profile.indicators.frequencyHint': 'Average gap between two logins',
  'profile.indicators.frequencyNone': 'Needs at least two logins',
  'profile.indicators.progress': 'Progress',
  'profile.indicators.progressHint': '{{done}} of {{total}} modules completed',
  'profile.info.title': 'Information',
  'profile.info.createdAt': 'Account created on',
  'profile.groups.empty': 'Not in any group.',
  'profile.sessions.title': 'Sessions',
  'profile.sessions.timeSpent': 'Time spent',
  'profile.sessions.finishedAt': 'Completed on',
  'profile.sessions.actions': 'Actions',
  'profile.sessions.progressValue': '{{done}}/{{total}} ({{pct}}%)',
  'profile.certificates.title': 'Certificates',
  'profile.certificates.empty': 'No certificate earned yet.',
  'profile.certificates.download': 'Download',
  'profile.certificates.downloadFor': 'Download the certificate for “{{name}}”',
  'profile.positioning.title': 'Positioning',
  'profile.positioning.empty': 'No path asks them for a positioning.',
  'profile.positioning.awaiting': 'Entry positioning not filled in yet.',
  'profile.positioning.tableFor': 'Positioning on “{{name}}”',
  'profile.positioning.objective': 'Objective',
  'profile.positioning.entry': 'Entry',
  'profile.positioning.exit': 'Exit',
  'profile.positioning.gap': 'Gap',
  'profile.positioning.needs': 'Expectations on entry:',
  'profile.logins.title': 'Logins',
  'profile.logins.retention': 'Logins are kept for 12 months.',
  'profile.logins.at': 'Date',
  'profile.logins.method': 'Sign-in method',
  'profile.logins.methods.PASSWORD': 'Password',
  'profile.logins.methods.MAGIC_LINK': 'Sign-in link',
  'profile.logins.methods.SSO': 'SSO',
  'tours.learnerProfile.title': 'User profile',
  'tours.learnerProfile.description': 'Everything known about a person, on a single page.',
  'tours.learnerProfile.header.title': 'The person',
  'tours.learnerProfile.header.body': 'Their name, role and account status. “Email” opens your mail app; an admin can also view their workspace, and reset the password of a username learner.',
  'tours.learnerProfile.indicators.title': 'The indicators',
  'tours.learnerProfile.indicators.body': 'Time spent in modules, logins over the last 12 months, the latest one, the average gap between two logins and progress across all their sessions.',
  'tours.learnerProfile.info.title': 'The information',
  'tours.learnerProfile.info.body': 'Their account, read-only, with their company and department. An admin corrects it with “Update”: the change is saved in the window that opens.',
  'tours.learnerProfile.groups.title': 'The groups',
  'tours.learnerProfile.groups.body': 'The groups they belong to. They are managed from the Groups screen or the user list.',
  'tours.learnerProfile.sessions.title': 'The sessions',
  'tours.learnerProfile.sessions.body': 'One row per session: status, progress, score (for a single-module course), time spent and completion date.',
  'tours.learnerProfile.attendance.title': 'The attendance statement',
  'tours.learnerProfile.attendance.body': '“Attendance statement”, on a session row, downloads as PDF what the learner followed: measured time per module, attempts, dates, scores, sign-in days, with the organization\'s attestation. For administrators.',
  'tours.learnerProfile.certificates.title': 'The certificates',
  'tours.learnerProfile.certificates.body': 'The certificates they earned, to download as PDF.',
  'tours.learnerProfile.positioning.title': 'The positioning',
  'tours.learnerProfile.positioning.body': 'For each path that asks for it: the level the learner gave themselves on each objective on entry, then on exit if they rated themselves again, the gap between both, and the expectations they stated at the start. It is the positioning and objectives evidence Qualiopi asks for (indicators 8 and 11).',
  'tours.learnerProfile.logins.title': 'The logins',
  'tours.learnerProfile.logins.body': 'Their logins over the last 12 months and the method used: password, sign-in link or SSO. Older ones are erased.',
  'helpDemo.learner.group': 'Sales team',
  'helpDemo.learner.course': 'Workplace safety',
  'helpDemo.learner.positioning.needs': 'Feel at ease welcoming the public from the first week.',
  'helpDemo.learner.positioning.objective1': 'Welcome a visitor following the procedure',
  'helpDemo.learner.positioning.objective2': 'Route a request to the right department',
  'helpDemo.path.documents.rules': 'Internal rules',
  'helpDemo.path.documents.booklet': 'Welcome booklet',
  'profile.loadError': 'The profile could not be loaded.',
  'profile.retry': 'Try again',

  // Configurable reports (#163)
  'common.routing.reports': 'Reports',
  'nav.group.statistics': 'Statistics',
  'reports.title': 'Reports',
  'reports.loadError': 'The report templates could not be loaded.',
  'reports.error': 'The operation failed. Try again.',
  'reports.downloadFailed': 'The report could not be downloaded.',
  'reports.tooLarge': 'This report exceeds 50,000 rows: narrow it by path, group, status or period.',
  'reports.created': 'Template created',
  'reports.saved': 'Template saved',
  'reports.duplicated': 'Template duplicated',
  'reports.deleted': 'Template deleted',
  'reports.copyName': 'Copy of {{name}}',
  'reports.discardTitle': 'Discard your changes?',
  'reports.discardBody': 'The template being edited is not saved: its changes will be lost.',
  'reports.discard': 'Discard',
  'reports.list.title': 'Report templates',
  'reports.list.empty': 'No report template yet: an administrator can build some.',
  'reports.list.emptyAdmin': 'No report template yet: build the first one below.',
  'reports.list.name': 'Name',
  'reports.list.granularity': 'One row per',
  'reports.list.columns': 'Columns',
  'reports.list.actions': 'Actions',
  'reports.list.download': 'Download',
  'reports.list.edit': 'Edit “{{name}}”',
  'reports.list.duplicate': 'Duplicate “{{name}}”',
  'reports.list.delete': 'Delete “{{name}}”',
  'reports.list.deleteTitle': 'Delete the template “{{name}}”?',
  'reports.list.deleteBody': 'The template goes for everyone; files already downloaded are not affected.',
  'reports.editor.newTitle': 'New template',
  'reports.editor.editTitle': 'Edit “{{name}}”',
  'reports.editor.name': 'Template name',
  'reports.editor.granularity': 'One row per',
  'reports.editor.create': 'Create the template',
  'reports.editor.newInstead': 'New template',
  'reports.granularity.LEARNER': 'Learner',
  'reports.granularity.ENROLLMENT': 'Learner path',
  'reports.granularity.MODULE': 'Path module',
  'reports.granularityHelp.LEARNER': 'One row per learner, their paths added up: number of paths, total time, overall status.',
  'reports.granularityHelp.ENROLLMENT': 'One row per learner and per path they are enrolled in.',
  'reports.granularityHelp.MODULE': 'One row per module of each path, never opened ones included.',
  'reports.level.learner': 'Learner',
  'reports.level.enrollment': 'Path',
  'reports.level.module': 'Module',
  'reports.columns.order': 'Column order in the file',
  'reports.columns.required': 'Tick at least one column.',
  'reports.columns.up': 'Move “{{column}}” up',
  'reports.columns.down': 'Move “{{column}}” down',
  'reports.filters.sessions': 'Paths (none ticked: all)',
  'reports.filters.groups': 'Groups (none ticked: all)',
  'reports.filters.noSessions': 'No path yet.',
  'reports.filters.noGroups': 'No group yet.',
  'reports.filters.state': 'Status',
  'reports.filters.anyState': 'Any status',
  'reports.filters.period': 'Activity period',
  'reports.filters.from': 'From',
  'reports.filters.to': 'To',
  'reports.filters.periodInvalid': 'Enter at least one date, and a start before the end.',
  'reports.filters.periodHelp': 'Keeps only the rows whose last activity falls in the period, recomputed at each download.',
  'reports.list.schedule': 'Email delivery',
  'reports.schedule.title': 'Email delivery',
  'reports.schedule.description': 'Receive this report automatically, as a CSV attachment, at the organisation\'s time.',
  'reports.schedule.saveFirst': 'Create the template first, then open it from the list (pencil) to schedule its delivery.',
  'reports.schedule.enabled': 'Send this report by email',
  'reports.schedule.frequency': 'Frequency',
  'reports.schedule.frequencies.WEEKLY': 'Every week',
  'reports.schedule.frequencies.MONTHLY': 'Every month',
  'reports.schedule.weekday': 'Day',
  'reports.schedule.monthDay': 'Day of the month',
  'reports.schedule.hour': 'Hour',
  'reports.schedule.hourOption': '{{hour}}:00',
  'reports.schedule.weekdays.1': 'Monday',
  'reports.schedule.weekdays.2': 'Tuesday',
  'reports.schedule.weekdays.3': 'Wednesday',
  'reports.schedule.weekdays.4': 'Thursday',
  'reports.schedule.weekdays.5': 'Friday',
  'reports.schedule.weekdays.6': 'Saturday',
  'reports.schedule.weekdays.7': 'Sunday',
  'reports.schedule.recipients': 'Recipients',
  'reports.schedule.recipientsSearch': 'Search recipients',
  'reports.schedule.recipientsRequired': 'Tick at least one recipient.',
  'reports.schedule.lastSent': 'Last sent: {{date}}',
  'reports.schedule.save': 'Save the delivery',
  'reports.schedule.stop': 'Delete the delivery',
  'reports.schedule.saved': 'Delivery saved',
  'reports.schedule.stopped': 'Delivery deleted',
  'reports.schedule.summary.WEEKLY': 'Weekly: {{day}}, {{hour}}:00',
  'reports.schedule.summary.MONTHLY': 'Monthly: day {{day}}, {{hour}}:00',
  'tours.reports.schedule.title': 'Email delivery',
  'tours.reports.schedule.body': 'For an existing template, opened from the list: choose every week (a day) or every month (from 1 to 28), an hour, and the administrators who will receive it as a CSV attachment — or trainers, as long as the organisation lets them export statistics. Click “Save the delivery”; untick “Send this report by email” to pause it, or “Delete the delivery” to stop it. A report too large arrives without attachment, with a link to this screen.',
  'reports.state.NOT_STARTED': 'Not started',
  'reports.state.IN_PROGRESS': 'In progress',
  'reports.state.COMPLETED': 'Completed',
  'reports.period.ALL': 'Whole period',
  'reports.period.LAST_7_DAYS': 'Last 7 days',
  'reports.period.LAST_30_DAYS': 'Last 30 days',
  'reports.period.CURRENT_MONTH': 'Current month',
  'reports.period.PREVIOUS_MONTH': 'Previous month',
  'reports.period.RANGE': 'Chosen dates',
  'tours.reports.title': 'Reports',
  'tours.reports.description': 'Download the organisation\'s CSV reports and, as an administrator, build their templates.',
  'tours.reports.list.title': 'The templates',
  'tours.reports.list.body': 'The organisation\'s report templates, by name, with what a row is and the number of columns. The “Email delivery” column says when it goes out. An administrator can also edit them (pencil), duplicate or delete them.',
  'tours.reports.download.title': 'Download',
  'tours.reports.download.body': '“Download” produces the template\'s CSV file, with the current data: headers are in the organisation\'s language, dates in its time zone. The file only contains learners. Beyond 50,000 rows the report is refused: narrow its filters.',
  'tours.reports.editor.title': 'Name the template',
  'tours.reports.editor.body': 'The editor builds a new template, or the one you chose to edit in the list. Give it a name, which is required.',
  'tours.reports.granularity.title': 'What a row is',
  'tours.reports.granularity.body': 'One row per learner, per learner path, or per module of each path. Changing this choice removes the columns it no longer allows.',
  'tours.reports.columns.title': 'The columns',
  'tours.reports.columns.body': 'Tick the columns, sorted by learner, path and module: each ticked box is added at the end of the file. On the right, the arrows change their order.',
  'tours.reports.filters.title': 'The filters',
  'tours.reports.filters.body': 'Narrow the report to paths, groups, a status (not started, in progress, completed) and an activity period. A period such as “previous month” is recomputed at each download.',
  'tours.reports.save.title': 'Save',
  'tours.reports.save.body': '“Create the template” or “Save” puts it in the list, ready to download. Nothing is kept until you click.',
  'credentials.title_one': 'Learner sign-in details',
  'credentials.title_other': 'Sign-in details of {{count}} learners',
  'credentials.once': 'Write them down or print the sheet now: the password won\'t be shown again. If it is lost, reset it from the list or the learner\'s profile.',
  'credentials.copy': 'Copy the password of {{username}}',
  'credentials.copied': 'Password copied.',
  'credentials.copyFailed': 'Copy failed: select the password and copy it by hand.',
  'credentials.sheet.download': 'Download the sheet',
  'credentials.sheet.failed': 'The sheet could not be generated. Try again.',
  'user.mode.label': 'How the learner signs in',
  'user.mode.email': 'Email address',
  'user.mode.username': 'Username and password',
  'user.mode.username.help': 'For a learner without an email address: they sign in with the username and password you give them. No email is sent to them.',
  'user.username.help': '3 to 64 characters: lowercase letters, digits, dot, dash or underscore.',
  'user.username.invalid': 'Invalid username: 3 to 64 characters, lowercase letters, digits, dot, dash or underscore.',
  'user.username.taken': 'This username is already used in your organization.',
  'user.password.optional.help': 'Leave empty to generate one. Otherwise at least 8 characters.',
  'user.password.tooShort': 'At least 8 characters.',
  'user.nameOptional.help': 'Optional: a username is enough if you\'d rather not record a name.',
  'good.add.usernameLearner': 'Learner created.',
  'credentials.reset.action': 'Reset the password',
  'credentials.reset.title': 'New password for {{username}}?',
  'credentials.reset.body': 'A password is generated and shown once, for you to give to the learner. The old one stops working and their open sessions are closed.',
  'credentials.reset.confirm': 'Reset',
  'credentials.reset.failed': 'The password could not be reset.',
  'import.username.help': 'CSV file with the columns {{headers}} (semicolon separator). Only the username is required. A password is generated for each learner; no email is sent.',
  'import.username.badHeader': 'Invalid headers. Expected at least: pseudo.',
  'import.error.INVALID_USERNAME': 'Invalid username',
  'import.error.USERNAME_ALREADY_USED': 'Username already used',
  'import.username.tooMany': '500 rows at most per import: split the file.',
  'user.password.tooLong': '128 characters at most.',
  'user.company': 'Company',
  'user.department': 'Department',
  'import.error.AFFILIATION_TOO_LONG': 'Company or department too long (200 characters at most)',
  'signup.tagline': 'Train.\nTrack.\nCertify.',
  'signup.tagline.sub': 'Your SCORM modules, your learners and their certificates in one place. No credit card needed.',
  'signup.sent.next.title': 'What happens next?',
  'signup.sent.next.confirm': 'Confirm your address with the link in the email.',
  'signup.sent.next.review': 'Our team reviews your request.',
  'signup.sent.next.access': 'Once approved, you get an email to set your password and open your space, as its first administrator.',
}
